Vendd.Scripts.load(function () {

    var configuratorOptions = {};

    (function ($) {
        $.getElement = function (element, $_wrapper) {
            if (!$_wrapper) return $("");
            var _wrapper = $_wrapper.get(0);
            var $items;
            if (_wrapper.config.isSubRecipe) {
                $items = $(element, $_wrapper);
            } else {
                $items = $("");
                $('.x-recipe-ingredients ' + element, $_wrapper).each(function (i, el) {
                    if ($(el).closest('.x-subrecipe').length === 0) {
                        $items.push(el);
                    }
                });
            }
            return $items;
        };
        $.getGlobalElement = function (element, $_wrapper) {
            if (!$_wrapper || $_wrapper.length === 0) return $("");
            var _wrapper = $_wrapper.get(0);
            var $items = $("");
            if (_wrapper.$recipe_container) {
                $(element, _wrapper.$recipe_container).each(function (i, el) {
                    $items.push(el);
                });
            }
            return $items;
        };
    })(jQuery);

    var recipeController = function ($wrapper, options, literals) {
        if ($wrapper.length < 1)
            return;
        var wrapper = $wrapper.get(0);

        var state = Vendd.Product.Controller.getState();
        var id = parseInt($wrapper.attr('data-id') || state.parentId),
            skuId = parseInt($wrapper.attr('data-skuid') || state.selectedId),
            path = state.path;
        wrapper.state = {};
        wrapper.state.id = id;
        wrapper.state.skuId = skuId;
        var current_product_id;
        var onIngredientsChanged = null;
        literals = literals || {};

        if ((id || 0) <= 0) return;

        wrapper.setOptions = function (options) {

            var _defaultConfiguration = {};


            _defaultConfiguration.isSubRecipe = $wrapper.hasClass('issubrecipe');

            _defaultConfiguration.$ParentWrapper = _defaultConfiguration.isSubRecipe ? $wrapper.parents('.x-recipe-ingredients-wrapper') : null;
            _defaultConfiguration.ParentWrapper = _defaultConfiguration.isSubRecipe ? $wrapper.parents('.x-recipe-ingredients-wrapper').get(0) : null;

            _defaultConfiguration.isComboPage = $wrapper.hasClass('combo');
            _defaultConfiguration.isConfigurationPage = $wrapper.hasClass('configuration-page');
            _defaultConfiguration.PartialHtml = $wrapper.attr("data-partialhtml") || "pdRecipeIngredients";
            _defaultConfiguration.DependecyHtml = $wrapper.attr("data-dependencies-html") || "pdRecipeDependencies";
            _defaultConfiguration.isFancyboxPopup = $wrapper.hasClass('configuration-page');
            _defaultConfiguration.ParentRecipeId = _defaultConfiguration.isSubRecipe ? parseInt($wrapper.parents('.x-recipe-ingredients-wrapper').get(0).model.RecipeId) || 0 : 0;
            _defaultConfiguration.ParentRecipeItemId = _defaultConfiguration.isSubRecipe ? parseInt($wrapper.parents('.x-recipe-ingredients-wrapper').get(0).model.RecipeItemId) || 0 : 0;

            _defaultConfiguration.RecipeItemId = wrapper.state.skuId;
            _defaultConfiguration.RecipeId = parseInt($wrapper.attr("data-recipe-id") !== undefined ? $wrapper.attr("data-recipe-id") || 0 : 0);
            _defaultConfiguration.HasAuthorizedPage = $wrapper.attr("data-hasauthorizedpage") !== undefined ? $wrapper.attr("data-hasauthorizedpage").toLowerCase() === "true" : false;
            _defaultConfiguration.HasAuthorizedSave = $wrapper.attr("data-hasauthorizedsave") !== undefined ? $wrapper.attr("data-hasauthorizedsave").toLowerCase() === "true" : true;
            _defaultConfiguration.LoadFromDatabase = $wrapper.attr("data-loadfromdatabase") !== undefined ? $wrapper.attr('data-loadfromdatabase').toLowerCase() === "true" : false;
            _defaultConfiguration.SaveToDatabase = $wrapper.attr("data-savetodatabase") !== undefined ? $wrapper.attr('data-savetodatabase').toLowerCase() === "true" : false;
            _defaultConfiguration.ShareConfiguration = $wrapper.attr("data-shareconfiguration") !== undefined ? $wrapper.attr('data-shareconfiguration').toLowerCase() === "true" : false;
            _defaultConfiguration.EmailConfiguration = $wrapper.attr("data-emailconfiguration") !== undefined ? $wrapper.attr('data-emailconfiguration').toLowerCase() === "true" : false;
            _defaultConfiguration.PdfExport = $wrapper.attr("data-pdfexport") !== undefined ? $wrapper.attr('data-pdfexport').toLowerCase() === "true" : false;
            _defaultConfiguration.SendToOneDealer = $wrapper.attr("data-onedealer") !== undefined ? $wrapper.attr('data-onedealer').toLowerCase() === "true" : false;
            _defaultConfiguration.HasSummaryPage = $wrapper.attr("data-hassummarypage") !== undefined ? $wrapper.attr('data-hassummarypage').toLowerCase() === "true" : false;
            _defaultConfiguration.HasQuantitySelectors = $wrapper.attr("data-hasquantityselectors") !== undefined ? $wrapper.attr('data-hasquantityselectors').toLowerCase() === "true" : false;
            _defaultConfiguration.SaveToLocalStorage = $wrapper.attr("data-savetolocalstorage") !== undefined ? $wrapper.attr('data-savetolocalstorage').toLowerCase() === "true" : false;
            _defaultConfiguration.OnLoadPageLoadFromLocalStorage = $wrapper.attr("data-onloadpageloadfromlocalstorage") !== undefined ? $wrapper.attr("data-onloadpageloadfromlocalstorage").toLowerCase() === "true" : false;
            _defaultConfiguration.Attributes = $wrapper.attr("data-attributes") || "";
            _defaultConfiguration.IngredientsAttributes = $wrapper.attr("data-ingredients-attributes") || "";
           
            _defaultConfiguration.HasStockLocator = ($wrapper.attr("data-has-stock-locator") || "false").toLowerCase() === "true";

            _defaultConfiguration.CalculateShippingCost = ($wrapper.attr("data-calculate-shipping-cost") || "false").toLowerCase() === "true";
            _defaultConfiguration.ShippingCostNotIncludeInPriceCountries = ($wrapper.attr("data-shipping-cost-not-include-price-countries") || "").split(",") || [];

            _defaultConfiguration.CalculateMaxCapacity = ($wrapper.attr("data-weight-calculate-max-capacity") || "false").toLowerCase() === "true";
            _defaultConfiguration.MaxCapacityAtributCode = $wrapper.attr("data-max-capacity-attribute-code") || "";

            _defaultConfiguration.StandardEquipmentWrapper = $wrapper.attr("data-standard-equipmnet-wrapper") || "[data-configurator-standard-equipmnet-wrapper]";
            _defaultConfiguration.ShowStandardEquipment = ($wrapper.attr("data-show-standard-equipmnet") || "true").toLowerCase() === "true";

            _defaultConfiguration.IsAuthorizedPage = false;

            _defaultConfiguration.HasTaxAndFee = ($wrapper.attr("data-has-taxandfee") || "false").toLowerCase() === "true";
            _defaultConfiguration.SortIngredientsBy = ($wrapper.attr("data-sort-ingredients-by") || "");
            _defaultConfiguration.Co2AttributeCode = ($wrapper.attr("data-co2-attribute-code") || "");
            _defaultConfiguration.DMSCodeAttributeCode = ($wrapper.attr("data-dmscode-attribute-code") || "");

            _defaultConfiguration.FuelTypeCodeAttributeCode = ($wrapper.attr("data-fueltypecode-attribute-code") || "FuelTypeCode");
            _defaultConfiguration.EngineDisplacementAttributeCode = ($wrapper.attr("data-enginedisplacement-attribute-code") || "EngineDisplacement");
            _defaultConfiguration.VehicleTypeCodeAttributeCode = ($wrapper.attr("data-vehicleTypeCode-attribute-code") || "VehicleTypeCode");

            _defaultConfiguration.BodyStyleCodeAttributeCode = ($wrapper.attr("data-bodystylecode-attribute-code") || "BodyStyleCode");
            _defaultConfiguration.GrossWeightAttributeCode = ($wrapper.attr("data-grossweight-attribute-code") || "grossWeight");
            _defaultConfiguration.NumberOfSeatsAttributeCode = ($wrapper.attr("data-numberofseats-attribute-code") || "numberOfSeats");

            _defaultConfiguration.IsWheelAttributeCode = ($wrapper.attr("data-iswheel-attribute-code") || "IsWheel");
            _defaultConfiguration.IsBodyAttributeCode = ($wrapper.attr("data-isbody-attribute-code") || "IsBody");
            _defaultConfiguration.IsSeatAttributeCode = ($wrapper.attr("data-isseat-attribute-code") || "IsSeat");

            _defaultConfiguration.ExternalProductImageUri = ($wrapper.attr("data-external-product-image-uri") || "");
            _defaultConfiguration.ExternalProductImageIsEnabled = _defaultConfiguration.ExternalProductImageUri !== "";
            _defaultConfiguration.ExternalProductImageType = ($wrapper.attr("data-external-product-image-type") || "vendallion");
            _defaultConfiguration.HasAddons = ($wrapper.attr("data-has-addons") || "false").toLowerCase() === "true";
            _defaultConfiguration.ShowSelectionOnErrorTooltip = ($wrapper.attr("data-show-selection-on-error-tooltip") || "false").toLowerCase() === "true";
            _defaultConfiguration.HasDependencies = ($wrapper.attr("data-has-dependencies") || "false").toLowerCase() === "true";

            wrapper.config = $.extend({}, _defaultConfiguration, options || {});
        };

        wrapper.setLiterals = function () {

            var _default = {};

            _default.UnAuthorizedText = literals["unauthorized_text"] || "You first need to log in in order to configure a trailer.Don’t have an account? Register Here! It’s FREE and it takes less than 30 seconds";
            _default.UnAuthorizedLoginText1 = literals["unauthorized_login_text1"] || "LOGIN TO YOUR ACCOUNT ";
            _default.UnAuthorizedLoginText2 = literals["unauthorized_login_text2"] || "You can also create an account here";
            _default.UnAuthorizedButtonText1 = literals["unauthorized_login_text1"] || "LOGIN TO YOUR ACCOUNT!";
            _default.UnAuthorizedButtonText2 = literals["unauthorized_login_text2"] || "You can also create account here";
            _default.InvalidRegistrationData = literals["invalid_data"] || "INVALID REGISTRATION DATA!";
            _default.TooltipPrevStep = literals["tooltip_prev_step"] || "Please go through previous steps";
            _default.Standard = literals["standard"] || "STANDARD";
            _default.Optional = literals["optional"] || "OPTIONAL";
            _default.NextStep = literals["next_step"] || "NEXT STEP";
            _default.ShowSummary = literals["show_summary"] || "SHOW SUMMARY";
            _default.BackToConfiguration = literals["back_to_configuration"] || "Back to configuration";
            _default.SummaryGeneralErrors = literals["SummaryGeneralErrors"] || "GENERAL ERRORS";
            _default.SummaryGeneralErrorsDescription = literals["SummaryGeneralErrorsDescription"] || "Please go <a>back to the configuration page</a> and review the following errors and/or inconsistencies:";
            _default.StandardEquipment = literals["standard_equipment"] || "STANDARD EQUIPMENT";
            _default.OptionalEquipment = literals["optional_equipment"] || "OPTIONAL EQUIPMENT";
            _default.OptionalEquipmentTotalPrice = literals["optional_equipment_total_price"] || "Optional equipment total price";
            _default.PricesText = literals["prices_text"] || "PRICES";
            _default.StandardPriceText = literals["prices_standard_price_text"] || "BASIC PRICE";
            _default.OptionalPriceText = literals["prices_optional_price_text"] || "OPTIONAL EQUIPMENT";
            _default.ShippingPriceText = literals["Delivery"] || "DELIVERY IN UK";
            _default.TotalPriceText = literals["prices_total_price_text"] || "TOTAL PRICE";
            _default.AvailableText = literals["available_text"] || "Available direct to your address - 30 days";
            _default.ShareText = literals["share_text"] || "SHARE";
            _default.DownloadPdfText = literals["download_pdf_text"] || "DOWNLOAD PDF";
            _default.SaveForLaterText = literals["save_for_later_text"] || "SAVE FOR LATER";
            _default.NoneOfBelow = literals["NoChoiceTxt"] || "None of below";
            _default.ViewStandardEquipments = literals["ViewStandardEquipmentsText"] || "View standard equipments";
            _default.EquipmentCode = literals["EquipmentCodeText"] || "Code";
            _default.Weight = literals["WeightText"] || "Weight (Kg)";


            _default.OutdatedEquipment = literals["OutdatedEquipment"] || "OUTDATED EQUIPMENT";
            _default.SubmitRegistration = literals["SubmitRegistration"] || "SUBMIT CONFIGURATION";
            _default.Summary = literals["summary"] || "Summary";
            _default.PricesVatNote = literals["PricesVatNote"] || "All prices excl. 20% VAT";
            _default.PricesIncludeVatNote = literals["PricesIncludeVatNote"] || "All prices incl. 20% VAT";
            _default.SaveConfigText = literals["SaveConfigText"] || "Save configuration";
            _default.FriendlyNameTitle = literals["FriendlyNameTitle"] || "Set a friendly name for this configuration:";
            _default.FriendlyNameSubTitle = literals["FriendlyNameSubTitle"] || "Friendly name";
            _default.FriendlyNameErrorMsg = literals["FriendlyNameErrorMsg"] || "Friendly name is required";
            _default.OkBtnText = literals["OkBtnText"] || "OK";
            _default.CancelBtnText = literals["CancelBtnText"] || "Cancel";
            _default.EmailText = literals["EmailText"] || "EMAIL";

            _default.error1080 = literals["error1080"] || "ADD AND REMOVE SAME ITEM";
            _default.error1081 = literals["error1081"] || "ADD ITEMS FROM SAME SINGLE GROUP";
            _default.error1082 = literals["error1082"] || "REMOVE ITEM CANNOT REMOVED";

            _default.DependencyTitle = literals["DependencyTitle"] || "Your configuration will change.";
            _default.DependencySubtitle = literals["DependencySubtitle"] || "You have added:";
            _default.DependencyBodyTitle = literals["DependencyBodyTitle"] || "YOU MUST ADD ONE OF THE FOLLOWING OPTIONS:";
            _default.DependencyRemoveTitle = literals["DependencyRemoveTitle"] || "THE FOLLOWING ITEMS WILL BE DELETED:";
            _default.DependencyAddTitle = literals["DependencyAddTitle"] || "THE FOLLOWING ITEMS WILL BE ADDED:";
            _default.DependencyPriceText = literals["DependencyPriceText"] || "Price";
            _default.DependencySelectButton = literals["DependencySelectButton"] || "Select";
            _default.DependencyAcceptButton = literals["DependencyAcceptButton"] || "Accept";
            _default.DependencyCancelButton = literals["DependencyCancelButton"] || "Cancel";

            wrapper.literals = $.extend({}, literals || {}, _default || {});
            Vendd.RecipeLibrary.Literals = wrapper.literals;
        };

        wrapper.setOptions(options);

        wrapper.setLiterals();

        wrapper.$recipe_container = wrapper.config.isComboPage ?
            $wrapper.closest('.page_ProductList') :
            wrapper.config.isConfigurationPage ? $wrapper.closest('.recipe-container') : $wrapper.closest('.x-product-details');

        var $versionSelector = $.getGlobalElement('.x-product-details-version-selector', $wrapper);

        var maxQuantity = 0,
            maxFreeQuantity = 0,
            maxedOut = 0,
            maxReplaceQuantity = 0,
            defaultQuantity = 0,
            currentQuantity = 0,
            recipeInitialPrice = parseFloat(stringToNumber($('.current-price').attr('data-price'))),
            comboRecipePrice = 0,
            recipePrice = recipeInitialPrice;
        wrapper.initModel = {}, wrapper.model = {}, shippingModel = {};

        // AL - Init wrapper.addons property and addons Id;
        wrapper.addons = {}
        wrapper.addons.currentId = 1000;
        wrapper.addons.newId = function () {
            this.currentId++;
            return this.currentId;
        }
        wrapper.addons.totalAddons = 10;

        var onCheckboxLabelClick = function (event) {
            var $this = $(this);
            var $input = $(" input[data-ingredientid]:not(.info-input)", $this).first();
            if (!$input) return;
            if ($(event.target).get(0) === $input.get(0)) return;
            if (wrapper.config.HasDependencies) {
                var ingredientId = $input.data("ingredientid");
                var result = Vendd.RecipeLibrary.GetIngedientByIngredientId(wrapper.model.RecipeItemId, ingredientId);
                if (!!result && !!result.success && !!(result.data || []) && !!(result.data || []).HasDependencies) {
                    var $ingredient = $this.closest(".ingredient");
                    if (!!$ingredient) {
                        var $dependenciesButton = $(".recipe-dependencies-button", $ingredient);
                        var $dependenciesContainer = $(".recipe-dependencies-button", $ingredient);
                        if (!!$dependenciesButton && !!$dependenciesContainer) {
                            $dependenciesButton.trigger("click");
                            return;
                        }
                    }
                }
            }
            if (!($input.is(":radio") && $input.is(":checked"))) {
                $input
                    .trigger("click");
            }
        };
        var checkboxChange = function (event) {
            wrapper.loading(true);
            if (this.checked) {
                ifChecked(event);
            } else {
                ifUnchecked(event);
            }
        };

        var ifChecked = function (event) {
            if ($(event.target).hasClass("loading")) return;
            if ($(event.target).hasClass("disabled")) return;
            $(event.target).addClass("loading");
            //var recipeId = id;
            var ingredientId = parseInt(event.target.dataset.ingredientid || "") || -1;
            var quantity = parseFloat(stringToNumber(event.target.dataset.quanta || "1") || 1);

            var result, ingredientIdFrom;
            if ($(event.target).is(":radio")) {
                var groupId = event.target.dataset.groupid;
                var $ingredientIdFrom = $("input[data-groupid='" + groupId + "'].active");
                if ($ingredientIdFrom.is(".option-nullable") || $(event.target).is(".option-nullable")) {
                    if ($ingredientIdFrom.is(".option-nullable")) {
                        result = Vendd.RecipeLibrary.AddIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
                    } else if ($ingredientIdFrom.length > 0) {
                        ingredientIdFrom = parseInt($ingredientIdFrom.get(0).dataset.ingredientid || "") || -1;
                        result = Vendd.RecipeLibrary.RemoveIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientIdFrom, quantity, true);
                    }

                } else {
                    if ($ingredientIdFrom.length > 0 && !$(event.target).hasClass("active")) {
                        ingredientIdFrom = parseInt($ingredientIdFrom.get(0).dataset.ingredientid || "") || -1;
                        result = Vendd.RecipeLibrary.ChangeIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientIdFrom, ingredientId);
                    } else {
                        result = Vendd.RecipeLibrary.AddIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
                    }
                }
            } else {
                result = Vendd.RecipeLibrary.AddIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
            }
            if (!result.success) {
                if (result.status.ErrorCodes.length > 0) {
                    wrapper.showErrorMessage($(event.target), result.status.ErrorCodes);
                }
            } else {
                wrapper.model = result.data.recipe || wrapper.model;
                var ingredient = _.find(wrapper.model.Ingredients, function (i) { return i.IngredientId === ingredientId; }) || {};
                if ((ingredient.SubRecipeId || 0) > 0) {
                    var $subRecipeWrapper = $(".x-recipe-ingredients-wrapper[data-recipe-id='" + ingredient.SubRecipeId + "']", $wrapper);
                    var subRecipeWrapper = $subRecipeWrapper.get(0);
                    subRecipeWrapper.setCheckedItems();
                    subRecipeWrapper.setEnabledItems();
                }
            }
            setTimeout(function () {
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
                $(event.target).removeClass("loading");
                wrapper.loading(false);
                if (wrapper.config.SaveToDatabase) wrapper.checkChanges();
                if (onIngredientsChanged !== null) onIngredientsChanged.resolve();
            }, 0);
        };

        var ifUnchecked = function (event) {
            if ($(event.target).hasClass("loading")) return;
            if ($(event.target).hasClass("disabled")) return;
            if ($(event.target).is(":radio")) return;
            $(event.target).addClass("loading");
            var ingredientId = parseInt(event.target.dataset.ingredientid || "") || -1;
            var quantity = parseFloat(stringToNumber(event.target.dataset.quanta || "1") || 1);
            var result = Vendd.RecipeLibrary.RemoveIngredient(wrapper.model, wrapper.model.RecipeItemId, ingredientId, quantity, true);
            if (!result.success) {
            } else {
                wrapper.model = result.data.recipe || wrapper.model;
            }
            setTimeout(function () {
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
                $(event.target).removeClass("loading");
                wrapper.loading(false);
                if (wrapper.config.SaveToDatabase) wrapper.checkChanges();
                if (onIngredientsChanged !== null) onIngredientsChanged.resolve();
            }, 0);
        };

        wrapper.loading = function (loading) {
            if (loading) {
                $wrapper.addClass('x-loading');
            } else {
                $wrapper.removeClass('x-loading');
            }
        };

        wrapper.loading(true);

        wrapper.update = function () {
            wrapper.model.Literals = wrapper.literals;
            $.each(wrapper.model.Categories, function (index, category) {
                $.each(category.Groups, function (indexInGroupArray, group) {
                    $.each(group.Items, function (indexInItemArray, item) {
                        if (item.Description === item.Name) {
                            item.Description = null;
                        }
                    });
                });
            });
            wrapper.model.ParentImageURL = $('.js-image-container img', wrapper.$recipe_container).attr('src'); //Custom BJT
            if (wrapper.model.ParentImageURL.indexOf("http") !== 0) wrapper.model.ParentImageURL = window.location.protocol + "//" + wrapper.model.ParentImageURL;
            wrapper.model.HasTaxAndFee = wrapper.config.HasTaxAndFee;
            wrapper.model.SendToOneDealer = wrapper.config.SendToOneDealer;
            var html = Vendd.Handlebars.parse(wrapper.config.PartialHtml, wrapper.model);
            wrapper.bind(html);

            if (!wrapper.config.isSubRecipe) {
                $('.x-recipe-ingredients-wrapper.issubrecipe', $wrapper).each(function (el, i) {
                    recipeController($(this), configuratorOptions, wrapper.model.Literals || {});
                });
            }
            if ($(".x-price-vat-selector").length > 0) {
                var priceSelector = $(".x-price-vat-selector").get(0);
                if (typeof priceSelector.toggleVat === "function")
                    priceSelector.toggleVat($wrapper);
            }

            if (wrapper.config.ExternalProductImageIsEnabled && !wrapper.config.isSubRecipe) {

                var initExternalImageButtons = function () {

                    var $buttons = $.getGlobalElement(".external-image-buttons-wrapper", $wrapper);
                    $(".external-image-button", $buttons).off("click touchstart").on('click touchstart', function (e) {
                        var $this = $(this);
                        if ($this.is(".disabled") || $this.is(".active")) return;
                        $(".external-image-button", $buttons).addClass("disabled");
                        if ($this.is(".view-button")) {
                            $(".external-image-button.view-button", $buttons).removeClass("active");
                            if (wrapper.config.ExternalProductImageType !== "vendallion") {
                                $(".external-image-button.angle-button", $buttons).removeClass("active");
                                $(".external-image-button.angle-button[data-angle='1']", $buttons).addClass("active");
                                if ($this.data("view") === "EXT") {
                                    $(".external-image-button.angle-button[data-angle='4']", $buttons).removeClass("hidden");
                                } else {
                                    $(".external-image-button.angle-button[data-angle='4']", $buttons).addClass("hidden");
                                }
                            }
                        }
                        else if ($this.is(".angle-button"))
                            $(".external-image-button.angle-button", $buttons).removeClass("active");
                        $this.addClass("active");
                        wrapper.seExternalImage();
                    });

                }
                if (wrapper.config.ExternalProductImageType === "one-dealer") {
                    $.when(Vendd.RecipeLibrary.GetOneDealerResourceView({ RecipeId: wrapper.model.RecipeItemId }))
                        .done(
                            function (response) {

                                var $buttons = $.getGlobalElement(".external-image-buttons-wrapper", $wrapper);
                                if ($buttons.length === 0) return;
                                var viewModel = {
                                    "Views": response.data
                                };
                                var viewHtml = Vendd.Handlebars.parse("pdResourceView", viewModel);
                                $buttons.html(viewHtml);
                                initExternalImageButtons();
                                return;
                            })
                        .fail(
                            function (response) {
                                var isAborted = (((response || {}).data || {}).statusText || "") === "abort";
                                if (!isAborted) {
                                    console.log("Views Error:", response);

                                }
                                return;
                            })
                        .always(
                            function (response) {
                                var isAborted = (((response || {}).data || {}).statusText || "") === "abort";
                                if (!isAborted) {
                                    console.log("Views Always:", response);
                                }
                                return;
                            });
                } else {
                    initExternalImageButtons();
                }
            }
        };

        wrapper.bind = function bind(html) {
            $wrapper.html(html);

            wrapper.setCheckedItems();
            wrapper.setEnabledItems();
            if (wrapper.config.SaveToDatabase) wrapper.checkChanges();

            wrapper.bindEvents();

            $wrapper.show();

        };

        wrapper.bindEvents = function () {

            wrapper.initIcheck();
            wrapper.initIngredientsToggle();
            wrapper.initNextStep();
            wrapper.initTooltips();

            $.getElement(' .label-container', $wrapper).off('click').on('click', onCheckboxLabelClick);
            $.getElement(' input[data-ingredientid]:checkbox:not(.info-input)', $wrapper).off('change').on('change', checkboxChange);
            $.getElement(" .info-error-container .info-error-btn", $wrapper).off("click touchstart").on("click touchstart", function (e) {
                if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                e.preventDefault();
                var $infoContainer = $(e.target).closest(".info-error-container");
                if ($infoContainer.hasClass("disabled")) return;
                var $errorHtml = $(".info-error-text", $infoContainer);
                $.fancybox.open($errorHtml, {
                    touch: {
                        vertical: false,
                        momentum: false
                    }
                });
            });
            if (wrapper.config.HasDependencies) {
                $.getElement(" .recipe-dependencies-button", $wrapper).off("click").on("click", function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    var ingredientId = $this.data("ingredientid");
                    var $dependency = $(`.recipe-dependencies-container[data-ingredientid="${ingredientId}"]`, $wrapper);
                    if (!!$dependency) {
                        var isCanceled = true;
                        $.fancybox.open($dependency, {
                            touch: false,
                            afterClose: function (e) {
                                if (!isCanceled) {
                                    wrapper.setCheckedItems();
                                    wrapper.setEnabledItems();
                                    if (wrapper.config.SaveToDatabase) wrapper.checkChanges();
                                }
                                wrapper.loading(false);
                            },
                            afterShow: function () {
                                $(".debendency-button-select", $dependency).off("click touchstart").on("click touchstart", function (e) {
                                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                                    e.preventDefault();
                                    var $this = $(this);
                                    if ($this.hasClass("active")) return;
                                    var $container = $this.closest(".recipe-dependencies-container");
                                    var $dependencyBox = $this.closest(".dependency-box");
                                    if ($dependencyBox.hasClass("invalid")) return;
                                    $(".dependency-box", $container).removeClass("active");
                                    $dependencyBox.addClass("active");
                                    $(".debendency-confirm-button-accept", $dependency).removeClass("disabled");

                                    var result = Vendd.RecipeLibrary.GetDependencies(wrapper.model.RecipeItemId);
                                    if (!result || !result.success || !(result.data || [])) return;
                                    var ingredient = _.find(result.data, function (x) { return x.IngredientId === ingredientId; });
                                    if (!ingredient) return;
                                    var guid = $dependencyBox.data("guid");
                                    if (!guid) return;
                                    var dependency = _.find((ingredient.DepedenciesIngredientsOnAdd || []), function (x) { return x.guid === guid; });
                                    if (!dependency) return;

                                    var priceText = numberToString2(ingredient.Price + dependency.Price, true);
                                    var priceWithoutVatText = numberToString2(ingredient.PriceWithoutVat + dependency.PriceWithoutVat, true);
                                    $(".debendency-confirm-total-price .price.price-with-vat", $container).text(priceText);
                                    $(".debendency-confirm-total-price .price.price-without-vat", $container).text(priceWithoutVatText);
                                });
                                $(".debendency-confirm-button-cancel", $dependency).off("click touchstart").on("click touchstart", function (e) {
                                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                                    e.preventDefault();
                                    $.fancybox.close();
                                });
                                $(".debendency-confirm-button-accept", $dependency).off("click touchstart").on("click touchstart", function (e) {
                                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                                    e.preventDefault();
                                    var $this = $(this);
                                    if ($this.hasClass("disabled")) return;
                                    var $container = $this.closest(".recipe-dependencies-container");
                                    var $selected = $(".dependency-box.active", $container);
                                    if (!$selected) {
                                        return;
                                    }
                                    var result = Vendd.RecipeLibrary.GetDependencies(wrapper.model.RecipeItemId);
                                    if (!result || !result.success || !(result.data || [])) return;
                                    var ingredient = _.find(result.data, function (x) { return x.IngredientId === ingredientId; });
                                    if (!ingredient) return;
                                    var guid = $selected.data("guid");
                                    if (!guid) return;
                                    var dependency = _.find((ingredient.DepedenciesIngredientsOnAdd || []), function (x) { return x.guid === guid; });
                                    if (!dependency) return;
                                    var addIngredientIds = (_.map((dependency.Add || []), function (x) { return x.IngredientId; })) || [];
                                    if (!ingredient.Checked) addIngredientIds.push(ingredientId);
                                    var removeIngredientIds = (_.map((dependency.Remove || []), function (x) { return x.IngredientId; })) || [];
                                    if (ingredient.Checked) removeIngredientIds.push(ingredientId);
                                    var resultAddRemoveIngredients = Vendd.RecipeLibrary.AddRemoveIngredients(wrapper.model, wrapper.model.RecipeItemId, addIngredientIds, removeIngredientIds, 1);
                                    if (!resultAddRemoveIngredients || !resultAddRemoveIngredients.success) {
                                        console.log(resultAddRemoveIngredients);
                                        return;
                                    }
                                    wrapper.loading(true);
                                    isCanceled = false;
                                    $.fancybox.close();
                                });
                            }

                        });
                    }
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getElement(' .js-summary-show-button', $wrapper).off('click touchstart').on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    if (wrapper.config.HasStockLocator) {
                        if (!wrapper.storeLocator.Partner && wrapper.storeLocator.CanChangeDealer) {
                            var callbacks = {};
                            callbacks.onClose = function () {
                                if (wrapper.storeLocator.Partner) {
                                    setTimeout(() => {
                                        wrapper.Validate();
                                    }, 100);
                                }
                            };
                            openPostCodeSelector(callbacks);
                        } else {
                            wrapper.Validate();
                        }
                    } else {
                        wrapper.Validate();
                    }
                });
                $.getGlobalElement(' .js-edit-post-code', $wrapper).off('click touchstart').on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    if (wrapper.config.HasStockLocator && wrapper.storeLocator.CanChangeDealer) {
                        openPostCodeSelector(null, true);
                    }
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement(' .back-to-config-container', $wrapper).off('click touchstart').on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    wrapper.showSummary(false);
                    scroll_to_class($wrapper, 90);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.js-submit-registration-button', $wrapper).off('click touchstart').on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    var $this = $(this);
                    if ($this.hasClass("loading")) return;
                    wrapper.loading(true);
                    $this.addClass("loading");
                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var $successHtml = $.getGlobalElement('.success-registration-text', $wrapper);
                            $.fancybox.open($successHtml, {
                                touch: false,
                                btnTpl: {
                                    smallBtn:
                                        '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                        'OK' +
                                        "</button> </div>"
                                },
                                afterClose: function () {
                                    parent.jQuery.fancybox.close();
                                }
                            });
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-for-later-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false,
                                    btnTpl: {
                                        smallBtn:
                                            '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                            'OK' +
                                            "</button> </div>"
                                    },
                                    afterClose: function () {
                                        parent.jQuery.fancybox.close();
                                    }
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        Force: true,
                        FriendlyName: "Register:" + wrapper.model.vin,
                        Vin: wrapper.model.vin,
                        PartnerId: wrapper.model.partnerId !== "" ? wrapper.model.partnerId : null
                    };

                    if (wrapper.Validate())
                        wrapper.saveData(callback, config);
                    else
                        callback.finally();
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.save-for-later-container .button', $wrapper).off("click touchstart").on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.SaveToDatabase || $this.hasClass("disabled")) return;
                    $this.addClass("loading");
                    wrapper.loading(true);
                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var location;
                            if (wrapper.config.HasAuthorizedSave && !wrapper.model.isAuthenticated) {
                                var $unauthorized = $.getGlobalElement(".unauthorized-container", $wrapper);
                                var $link = $("a", $unauthorized);
                                location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
                                location = UpdateQueryString("DoSave", true, location);
                                $link.attr("href", LhApp.Url.Page.Login + "?returnUrl=" + encodeURIComponent(location));
                                $.fancybox.open($unauthorized, {
                                    touch: {
                                        vertical: false,
                                        momentum: false
                                    }
                                });
                            } else {
                                var $successHtml = $.getGlobalElement('.success-for-later-text', $wrapper);
                                location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
                                $("#saved-url", $successHtml).val(location);
                                $.fancybox.open($successHtml, {
                                    touch: false
                                });
                            }
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-for-later-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    if (wrapper.config.isConfigurationPage) {
                        var config = {
                            Force: true,
                            FriendlyName: "Register:" + wrapper.model.vin,
                        }
                        wrapper.saveData(callback, config);
                    } else {
                        var $fancyprompt = $(".fancybox-prompt-container");
                        if ($fancyprompt.length > 0) {
                            fancyPrompt($fancyprompt, $(".product-name").text() || "", function (friendlyName) {
                                if (friendlyName !== null && friendlyName !== "") {
                                    var config = {
                                        Force: true,
                                        FriendlyName: friendlyName
                                    }
                                    wrapper.saveData(callback, config);
                                } else {
                                    $this.removeClass("loading");
                                    wrapper.loading(false);
                                }
                            });
                        }
                    }

                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement(' .download-pdf-container .button', $wrapper).off("click touchstart").on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    e.preventDefault();
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.PdfExport || $this.hasClass("disabled")) return;
                    $this.addClass("loading");
                    wrapper.loading(true);

                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;

                            generatePDF($this);
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-download-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false
                                }
                            });
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }, finally: function () {
                        }
                    };
                    var config = {
                        FriendlyName: "Share",
                        IsShare: true
                    };
                    wrapper.saveData(callback, config);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement(' .share-buttons .button', $wrapper).off("click touchstart").on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.ShareConfiguration || $this.hasClass("disabled")) return;
                    $this.addClass("loading");
                    wrapper.loading(true);

                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
                            addthis.update('share', 'url', location);
                            addthis.url = location;
                            addthis.toolbox(".addthis_sharing_toolbox");
                            $(".addthis_inline_share_toolbox").toggleClass("hidden", false);
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-share-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        FriendlyName: "Share",
                        IsShare: true
                    };
                    wrapper.saveData(callback, config);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement(' .email-buttons .button', $wrapper).off("click touchstart").on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    //στο email οταν σωζουμε, θα πρεπει να μπαινει friendly name οεο;
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.EmailConfiguration || $this.hasClass("disabled")) return;
                    $this.addClass("loading");
                    wrapper.loading(true);

                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
                            window.location.href = "mailto:?body=" + encodeURIComponent(location);
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-email-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        FriendlyName: "Share",
                        IsShare: true
                    };
                    wrapper.saveData(callback, config);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.start-over-container', $wrapper).off("click touchstart").on('click touchstart', function (event) {
                    if ('ontouchstart' in document.documentElement && event.type !== "touchstart") return;
                    if ($(event.target).hasClass("disabled")) return;
                    wrapper.loading(true);
                    scroll_to_class($wrapper, 90);
                    $(event.target).addClass("disabled");
                    Vendd.RecipeLibrary.ResetRecipe(wrapper.initModel, id);
                    Vendd.RecipeLibrary.ClearLocalStorage();
                    wrapper.model = $.extend(true, {}, wrapper.initModel);
                    $.getElement(" .globalid-container", $wrapper).text(wrapper.model.GlobalId);
                    $.getElement(" .hashcode-container", $wrapper).text(wrapper.model.HashCode);
                    $.getElement(' input[data-ingredientid]', $wrapper).addClass("loading");
                    wrapper.update();
                    $(event.target).removeClass("disabled");
                    $(".recipe-buttons-container .js-full-screen-popup").addClass("disabled");
                    wrapper.showSummary(false);
                    wrapper.loading(false);
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.fancybox-copy-to-clipboard', $wrapper).off("click touchstart").on("click touchstart", function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    copyToClipboard();
                    $(this).addClass("copied").delay(1000).queue(function () {
                        $(this).removeClass("copied").dequeue();
                    });
                });
            }
            if (!wrapper.config.isSubRecipe) {
                $.getGlobalElement('.one-dealer-container .button', $wrapper).off("click touchstart").on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    var $this = $(this);
                    if ($this.hasClass("loading") || !wrapper.config.SendToOneDealer || $this.hasClass("disabled")) return;
                    wrapper.loading(true);
                    $this.addClass("loading");
                    var callback = {
                        success: function (response) {
                            wrapper.model.GlobalId = response.GlobalId;
                            wrapper.model.HashCode = response.HashCode;
                            wrapper.checkChanges();
                            var oneDealerResponse = Vendd.RecipeLibrary.GetOneDealerData(wrapper.model.RecipeItemId);
                            window.VenddDebug_oneDealerResponse = oneDealerResponse;
                            if ((oneDealerResponse.data.Guid || "") === "") {
                                var $errorHtml = $.getGlobalElement('.error-for-later-text', $wrapper);
                                $.fancybox.open($errorHtml, {
                                    touch: {
                                        vertical: false,
                                        momentum: false,
                                        btnTpl: {
                                            smallBtn:
                                                '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                                'OK' +
                                                "</button> </div>"
                                        },
                                        afterClose: function () {
                                            parent.jQuery.fancybox.close();
                                        }
                                    }
                                });
                                return;
                            }
                            if (window.parent) {
                                if (oneDealerResponse.success) {
                                    window.parent.postMessage(oneDealerResponse.data, "*");
                                }
                            }
                        }, error: function () {
                            var $errorHtml = $.getGlobalElement('.error-for-later-text', $wrapper);
                            $.fancybox.open($errorHtml, {
                                touch: {
                                    vertical: false,
                                    momentum: false,
                                    btnTpl: {
                                        smallBtn:
                                            '<div class="containerButtonFancy"><button type="button" data-fancybox-close class="fancybox-button configurator-fancybox-close-small" title="{{CLOSE}}">' +
                                            'OK' +
                                            "</button> </div>"
                                    },
                                    afterClose: function () {
                                        parent.jQuery.fancybox.close();
                                    }
                                }
                            });
                        }, finally: function () {
                            $this.removeClass("loading");
                            wrapper.loading(false);
                        }
                    };
                    var config = {
                        Force: true,
                        FriendlyName: "OneDealer:" + wrapper.model.vin
                    };
                    wrapper.saveData(callback, config);
                });
            }

            if (!wrapper.config.isSubRecipe && wrapper.config.HasAddons) {
                wrapper.addons.$categoryAddons = $.getGlobalElement('.x-category-addon', $wrapper);
                var $addonsList = $('.addons', wrapper.addons.$categoryAddons);
                                
                if ((wrapper.model.Addons || []).length == 0) {
                    appendNewAddon($addonsList);
                }
                
                $('.add-new .button', wrapper.addons.$categoryAddons).on("click", function () {
                    appendNewAddon($addonsList);
                })
            }
        };

        var bindSingleAddonEvents = function ($addonEl) {
            $('.edit-buttons .cancel', $addonEl).on("click", function () {
                handleCancelAddon($addonEl);
            })
            $('.edit-buttons .edit', $addonEl).on("click", function () {
                handleEditAddon($addonEl);
            })
            $('.edit-buttons .delete', $addonEl).on("click", function () {
                handleDeleteAddon($addonEl);
            })
            $('.edit-buttons .save', $addonEl).on("click", function () {
                handleSaveAddon($addonEl);
            })
            $('.price-container .price.edit', $addonEl).on("keydown", function (e) {
                if (e.keyCode !== 190 && e.keyCode !== 110) {
                    numbersOnly(e);
                }
            })
            $('.text-details .weight.edit', $addonEl).on("keydown", function (e) {
                if (e.keyCode !== 190 && e.keyCode !== 110) {
                    numbersOnly(e);
                }
            })
            $('.text-details .co2.edit', $addonEl).on("keydown", function (e) {
                if (e.keyCode !== 190 && e.keyCode !== 110) {
                    numbersOnly(e);
                }
            })
            $('.text-details .name', $addonEl).on("focus", function () {
                $('.addon-error-container', $addonEl).addClass('hidden');
            })
            $('.price-container .price.edit', $addonEl).on("focus", function () {
                $('.addon-error-container', $addonEl).addClass('hidden');
            })
        }

        var appendNewAddon = function ($addonsList) {
            var addonModel = {
                "Literals": wrapper.literals
            };
            var html = Vendd.Handlebars.parse('pdRecipeAddon', addonModel);
            $addonsList.append(html);
            var $newAddon = $('.addon.editing', $addonsList);
            $newAddon.attr('data-id', wrapper.addons.newId());

            if ((wrapper.model.Addons || []).length > 0) {
                $newAddon.addClass('cancel-visible');
            }

            bindSingleAddonEvents($newAddon);
            wrapper.addons.$categoryAddons.addClass('editing');
        }

        var handleCancelAddon = function ($addonEl) {
            if ($addonEl.hasClass('empty')) {
                $addonEl.remove();
            }

            $('.addon-error-container', $addonEl).addClass('hidden');
            $addonEl.removeClass('editing');
            wrapper.addons.$categoryAddons.removeClass('editing');
        }

        var handleEditAddon = function ($addonEl) {
            var content = {};
            content.Name = $('.name.content', $addonEl).text().trim();
            content.Code = $('.code .code-content', $addonEl).text().trim();
            content.Weight = $('.weight .weight-content', $addonEl).text().trim();
            content.Co2 = $('.co2.content', $addonEl).text().trim();
            content.PriceWithVat = $('.price-with-vat.content', $addonEl).attr('data-price') || 0;
            content.PriceWithoutVat = $('.price-without-vat.content', $addonEl).attr('data-price') || 0;

            $('.name.edit', $addonEl).val(content.Name);
            $('.code.edit', $addonEl).val(content.Code);
            $('.weight.edit', $addonEl).val(content.Weight);
            $('.co2.edit', $addonEl).val(content.Co2);

            if ((window.localStorage.getItem("ShowVat") + "").toLowerCase() === "true") {
                $('.price.edit', $addonEl).val(content.PriceWithVat);
            } else {
                $('.price.edit', $addonEl).val(content.PriceWithoutVat);
            }

            $addonEl.addClass('editing');
            wrapper.addons.$categoryAddons.addClass('editing');
        }

        var handleDeleteAddon = function ($addonEl) {
            var addonId = parseInt($addonEl.attr('data-id'));
            var priceWithVat = $('.price-with-vat', $addonEl).attr('data-price');
            var priceWithoutVat = $('.price-without-vat', $addonEl).attr('data-price');

            var addonObj = {
                Id: addonId,
                Price: parseFloat(priceWithVat),
                PriceWithoutVat: parseFloat(priceWithoutVat)
            }

            var result = Vendd.RecipeLibrary.RemoveAddon(wrapper.model, wrapper.model.RecipeItemId, addonObj);

            if (!result.success) {
                if (result.status.ErrorCodes.length > 0) {
                    wrapper.showErrorMessage($(event.target), result.status.ErrorCodes);
                }
            } else {
                wrapper.model = result.data.recipe || wrapper.model;
                wrapper.calculateWeight();
                wrapper.calculateCo2();
                if (wrapper.config.HasTaxAndFee) {
                    wrapper.calculatePrice(false);
                    wrapper.getTaxAndFee();
                } else {
                    wrapper.calculatePrice(false);
                }
            }
            $addonEl.remove();
            var $addonsList = $('.addons', wrapper.addons.$categoryAddons);
            var $addons = $('.addon', $addonsList);
            if ($addons.length < 1) appendNewAddon($addonsList);
            wrapper.addons.checkTotal();
        }

        var handleSaveAddon = function ($addonEl) {
            var edited = {};
            edited.Id = parseInt($addonEl.attr('data-id'));
            edited.Name = $('.name.edit', $addonEl).val();
            edited.Code = $('.code.edit', $addonEl).val();
            edited.Weight = $('.weight.edit', $addonEl).val();
            edited.Co2 = $('.co2.edit', $addonEl).val();
            edited.Price = $('.price.edit', $addonEl).val() || '';

            if (edited.Name === '' || edited.Price === '') {
                $('.addon-error-container', $addonEl).text(wrapper.literals.AddOn_Error).removeClass('hidden');
                return;
            } else {
                $addonEl.removeClass('empty').removeClass('cancel-visible');
            }

            if ((window.localStorage.getItem("ShowVat") + "").toLowerCase() === "true") {
                edited.PriceWithVat = parseFloat(edited.Price).toFixed(2) || 0;
                edited.PriceWithoutVat = parseFloat(Vendd.RecipeLibrary.RemoveVat(wrapper.model.RecipeItemId, edited.PriceWithVat)).toFixed(2) || 0;
                $('.price-without-vat', $addonEl).addClass('hidden');
            } else {
                edited.PriceWithVat = parseFloat(Vendd.RecipeLibrary.AddVat(wrapper.model.RecipeItemId, edited.Price)).toFixed(2) || 0;
                edited.PriceWithoutVat = parseFloat(edited.Price).toFixed(2) || 0;
                $('.price-with-vat', $addonEl).addClass('hidden');
            }

            $('.name.content', $addonEl).text(edited.Name);
            $('.code .code-content', $addonEl).text(edited.Code);
            $('.weight .weight-content', $addonEl).text(edited.Weight);
            $('.co2', $addonEl).text(edited.Co2);
            $('.price-with-vat.content', $addonEl).text(Vendd.RecipeLibrary.PriceFormat(edited.PriceWithVat) + ' €')
                .attr('data-price', edited.PriceWithVat);
            $('.price-without-vat.content', $addonEl).text(Vendd.RecipeLibrary.PriceFormat(edited.PriceWithoutVat) + ' €')
                .attr('data-price', edited.PriceWithoutVat);

            var addonObj = {                
                Id: edited.Id,
                Name: edited.Name,
                Code: edited.Code,
                Weight: parseFloat(edited.Weight) || 0,
                Co2: parseInt(edited.Co2) || 0,
                Price: parseFloat(edited.PriceWithVat) || 0,
                PriceWithoutVat: parseFloat(edited.PriceWithoutVat) || 0
            }

            var result = Vendd.RecipeLibrary.AddNewAddon(wrapper.model, wrapper.model.RecipeItemId, addonObj);

            if (!result.success) {
                if (result.status.ErrorCodes.length > 0) {
                    wrapper.showErrorMessage($(event.target), result.status.ErrorCodes);
                }
            } else {
                wrapper.model = result.data.recipe || wrapper.model;
                wrapper.calculateWeight();
                wrapper.calculateCo2();
                wrapper.setAddonsSummary();
                if (wrapper.config.HasTaxAndFee) {
                    wrapper.calculatePrice(false);
                    wrapper.getTaxAndFee();
                } else {
                    wrapper.calculatePrice(false);
                }
            }

            $addonEl.removeClass('editing');
            wrapper.addons.$categoryAddons.removeClass('editing');
            wrapper.addons.checkTotal();
        }
        wrapper.setAddonsSummary = function () {

            $.getGlobalElement(" .summary-category-addons .category-item.generated", $wrapper).remove();
            var $template = $.getGlobalElement(".summary-item-generate-template", $wrapper);
            _.each(wrapper.model.Addons || [], function (item) {
                if (item.AddonId !== 0) {
                    var $templateClone = $template.clone().removeClass("summary-item-generate-template").addClass("generated");

                    $(".summary-item-name", $templateClone).text(item.Name);
                    $(".summary-item-category", $templateClone).text(item.Category);
                    var price = item.Price > 0 ? numberToString2(item.Price, true) : numberToString2(0, true);
                    $(".summary-item-price", $templateClone).text(price);
                    var priceWithoutVat = item.PriceWithoutVat > 0 ? numberToString2(item.PriceWithoutVat, true) : numberToString2(0, true);
                    $(".summary-item-price-without-vat", $templateClone).text(priceWithoutVat);
                    var $parent = $(".summary-category-addons .category-items");
                    $templateClone.prependTo($parent);
                }
            });

            $.getElement(" .category.summary-category-addons", $wrapper).toggleClass("hidden", (wrapper.model.Addons || []).length === 0);

        }

        wrapper.initAddonsList = function () {
            if ((wrapper.model.Addons || []).length < 1) return;

            var showVat = (localStorage.getItem('ShowVat') === "true") ? true : false;

            wrapper.addons.$categoryAddons = $.getGlobalElement('.x-category-addon', $wrapper);
            var $addonsList = $('.addons', wrapper.addons.$categoryAddons);

            _.each(wrapper.model.Addons || [], function (item) {
                item.PriceText = numberToString2(item.Price, true);
                item.PriceWithoutVatText = numberToString2(item.PriceWithoutVat, true);
                wrapper.addons.currentId = item.AddonId;

                item.Literals = wrapper.literals;
                var html = Vendd.Handlebars.parse('pdRecipeAddon', item);
                $addonsList.append(html);
                var $newAddon = $('.addon.editing', $addonsList);

                if (showVat) {
                    $('.price-without-vat', $newAddon).addClass('hidden');
                } else {
                    $('.price-with-vat', $newAddon).addClass('hidden');
                }

                $newAddon.attr('data-id', item.AddonId).removeClass('editing').removeClass('empty');
                bindSingleAddonEvents($newAddon);
            });

            wrapper.addons.$categoryAddons.removeClass('editing');
            wrapper.setAddonsSummary();
        }

        wrapper.addons.checkTotal = function () {
            if ((wrapper.model.Addons || []).length == wrapper.addons.totalAddons) {
                wrapper.addons.$categoryAddons.addClass('add-new-hidden');
            } else if ((wrapper.model.Addons || []).length < wrapper.addons.totalAddons) {
                wrapper.addons.$categoryAddons.removeClass('add-new-hidden');
            }
        }

        var openPostCodeSelector = function (callbacks, force) {
            force = force !== false;
            wrapper.storeLocator.Mpc = wrapper.storeLocator.Mpc || $(".js-edit-post-code").data("mpc");
            if ((!wrapper.storeLocator.Partner && wrapper.storeLocator.CanChangeDealer) || force) {
                callbacks = callbacks || {};
                callbacks.onClose = callbacks.onClose || function () {
                };
                callbacks.onStoreSelected = callbacks.onStoreSelected || function (store) {
                    if (store) {
                        $('.js-partner-info .dealer-info-msg').html('');
                        $('.js-partner-info .partner-name').html(store.LocalizedProperties[0].Name);
                        $('.js-partner-info .partner-address').html(store.Address);
                        $('.js-partner-info .partner-email').html(store.Email);
                        $('.js-partner-info .partner-phone').html([store.Phone, store.Mobile].filter(Boolean).join(", "));
                        $('.attributes-list .partner-name').addClass("bold").html(store.LocalizedProperties[0].Name);
                        $('.attributes-list .partner-address').addClass("bold").html(store.Address);
                        $('#PopUpCustomForm').get(0).formData.partner_name = store.LocalizedProperties[0].Name;
                        $('#PopUpCustomForm').get(0).formData.partner_address = store.Address;
                        $('#PopUpCustomForm').get(0).formData.partner_email = store.Email || '';
                        $('#PopUpCustomForm').get(0).formData.partner_phone = store.Phone || '';
                        $('#PopUpProductConfig').get(0).formData.partner_email = store.Email || '';
                    }
                };
                wrapper.storeLocator.SetCallbacks(callbacks);
                wrapper.storeLocator.storeSelector(callbacks);
            }
        };

        var fancyPrompt = function ($element, initVal, callback) {
            var value;
            $.fancybox.open($element, {
                touch: {
                    vertical: false,
                    momentum: false
                },
                beforeShow: function () {
                    $('input', $element).val(initVal);
                },
                afterShow: function () {
                    $element.on('keyup', function (event) {
                        if (event.keyCode === 27) {
                            value = null;
                            $.fancybox.close();
                        }
                        if (event.keyCode === 13) {
                            $(".fancybox-prompt-ok").trigger("click");
                        }
                    });
                    $('input', $element).change(function () {
                        $('.error-wrapper', $element).addClass(".hidden");
                    });
                    $(".fancybox-prompt-button").off("click touchstart").on("click touchstart", function (event) {
                        if ('ontouchstart' in document.documentElement && event.type !== "touchstart") return;
                        if ($(event.target).is(".fancybox-prompt-ok")) {
                            value = $('input', $element).val();
                            if (value === "") {
                                $('.error-wrapper', $element).removeClass(".hidden");
                            }
                        } else {
                            value = null;
                        }
                        $.fancybox.close();
                    });
                    $('input', $element).focus();
                },
                afterClose: function () {
                    $element.off('keyup');
                    callback.call(this, value);
                }
            });
        };

        var getUserData = function () {
            var user = JSON.parse(localStorage.getItem("CurrentUserModel"));
            var fullname = user.FirstName + ' ' + user.LastName;
            $('.pdf-header-container .user-name', $('.js-pdf-header')).html(fullname);
            if (user.IsAuthenticated) {
                $(".pdf-header-subtitle").hide();
                $(".authenticatedSubtitle").show();
            }
            else {
                $(".pdf-header-subtitle").show();
                $(".authenticatedSubtitle").hide();
            }
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            today = dd + '.' + mm + '.' + yyyy;
            $('.pdf-header-container .user-time', $('.js-pdf-header')).html(today);
        };

        var generatePDF = function ($el) {
            $button = $el;
            var coverPdf = null;
            if ($button.data('coverpdf') !== '') {
                coverPdf = 'https:' + $button.data('coverpdf');
            }
            getUserData();
            var location = UpdateQueryString("GlobalId", wrapper.model.GlobalId);
            var generatePDFAfterShortener = function () {
                $(".qr-wrapper img").attr({
                    "width": 120,
                    "height": 120
                });
                var requestData = {
                    "url": null,
                    "externalLink": coverPdf,
                    "externalLinkFirst": null,
                    "filename": "configurator",
                    "filenamehassuffixdatetime": true,
                    "pagesize": null,
                    "pageorientation": null,
                    "parameters": {
                        "hasprintcss": true
                    },
                    html: getHtmlBodyForPdf(),
                    headerhtml: getHtmlHeaderForPdf(),
                    footerhtml: getHtmlFooterForPdf(),
                    "HeaderHeight": 150,
                    "FooterHeight": 50,
                    "margin": {
                        "top": 0,
                        "bottom": 0,
                        "left": 25,
                        "right": 25
                    }
                };
                var successDownload = function (pdf) {
                    const blob = b64toBlob(pdf.FileContents, 'application/pdf');
                    const blobUrl = URL.createObjectURL(blob);
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, pdf.Filename);
                    } else {
                        var a = document.createElement("a");
                        a.style.visibility = 'hidden';
                        document.body.appendChild(a);
                        var fileURL = URL.createObjectURL(blob);
                        a.href = fileURL;
                        a.download = pdf.Filename;
                        a.click();
                        document.body.removeChild(a);
                        setTimeout(function () {
                        }, 500);
                    }
                };
                var errorDownload = function (response) {
                    var $errorHtml = $('.error-download-text', wrapper.$recipe_container);
                    $.fancybox.open($errorHtml, {
                        touch: {
                            vertical: false,
                            momentum: false
                        }
                    });
                };
                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    url: "/services/api/PdfExporter/Generate",
                    async: false,
                    data: JSON.stringify(requestData),
                    success: successDownload,
                    error: errorDownload,
                    complete: function (response) {
                        $button.removeClass("loading");
                        wrapper.loading(false);
                    }
                });
            };
            getShortenedUrl(location, generatePDFAfterShortener)
        };

        var getHtmlHeaderForPdf = function () {
            $("header img").each(function (i, img) {
                var $img = $(img);
                $img
                    .attr("data-width", $img.width())
                    .attr("data-height", $img.height());
            });
            var $bodyclone = $("html").clone();
            var $pdfHeader = $(".js-pdf-header").clone();
            $("img", $pdfHeader).each(function (i, img) {
                var $img = $(img);
                var src = $img.attr("src");
                if (src.startsWith("//")) $img.attr("src", "https:" + src);
            });
            return $pdfHeader.html();
        };

        var getHtmlFooterForPdf = function () {
            var $pdfFooter = $(".js-pdf-footer").clone();
            $("img", $pdfFooter).each(function (i, img) {
                var $img = $(img);
                var src = $img.attr("src");
                if (src.startsWith("//")) $img.attr("src", "https:" + src);
            });
            return $pdfFooter.html();
        };

        var getHtmlBodyForPdf = function () {

            $("img").each(function (i, img) {
                var $img = $(img);
                $img
                    .attr("data-width", $img.width())
                    .attr("data-height", $img.height());
            });
            var $bodyclone = $("html").clone();
            $("script", $bodyclone).remove();
            $(".js-pdf-header, .js-pdf-footer", $bodyclone).remove();
            var maxWidth = 400;
            var maxHeight = 200;
            $("img", $bodyclone).each(function (i, img) {
                if ($(this).attr("src") !== undefined) {
                    var $img = $(img);
                    var src = $img.attr("src");
                    if (src.startsWith("//")) $img.attr("src", "https:" + src);
                    var scaleWidth = maxWidth / $img.attr("data-width");
                    if (scaleWidth > 1) scaleWidth = 1;
                    var scaleHeight = maxHeight / $img.attr("data-height");
                    if (scaleHeight > 1) scaleHeight = 1;
                    var scale = scaleWidth < scaleHeight ? scaleWidth : scaleHeight;
                    var width = $img.attr("data-width") * scale;
                    var height = $img.attr("data-height") * scale;
                    $img
                        .width(width + "px")
                        .height(height + "px");
                }
            });
            $(".js-date-printed", $bodyclone).each(function (i, el) {
                $(el).css('display', 'block');
            });

            if (wrapper.config.isConfigurationPage) {
                $(".configurator-container", $bodyclone).toggleClass("hidden", true);
                $(".summary-container", $bodyclone).toggleClass("hidden", false);
            }
            return $bodyclone
                .html()
                .replace(/(")/gm, "'")
                .replace(/(\\)/gm, "\\\\")
                .replace(/(\r\n|\n|\r)/gm, "");
        };

        var b64toBlob = function (b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        };

        wrapper.saveData = function (callback, config) {
            var save = function (callback, config) {
                var htmlData = {
                    Body: getHtmlBodyForPdf(),
                    Header: getHtmlHeaderForPdf(),
                    Footer: getHtmlFooterForPdf()
                };

                var defaultConfiguration = {
                    RecipeId: wrapper.model.RecipeItemId,
                    Force: false,
                    FriendlyName: "",
                    Vin: wrapper.model.vin,
                    PartnerId: wrapper.model.partnerId !== "" ? wrapper.model.partnerId : null,
                    HtmlData: htmlData,
                    callback: callback
                };
                config = $.extend({}, defaultConfiguration, config || {});

                $.when(Vendd.RecipeLibrary.GenerateGlobalId(config))
                    .done(
                        function (response) {
                            if (callback && callback.success) callback.success(response.data);
                            return;
                        })
                    .fail(
                        function (response) {
                            if (callback && callback.error) callback.error(response);
                            return;
                        })
                    .always(
                        function (response) {
                            if (callback && callback.finally) callback.finally(response);
                            return;
                        });
            };
            if (wrapper.config.HasStockLocator) {
                if (!wrapper.storeLocator.Partner && wrapper.storeLocator.CanChangeDealer) {
                    var callbacks = {};
                    callbacks.onClose = function () {
                        if (wrapper.storeLocator.Partner) {
                            save(callback, config);
                        }
                    };
                    openPostCodeSelector(callbacks);
                    return;
                }
            }
            save(callback, config);
        };

        wrapper.loadData = function (callback, config) {

            var defaultConfiguration = {
                RecipeId: wrapper.model.RecipeItemId
            };
            var _config = $.extend({}, defaultConfiguration, config || {});

            if (wrapper.config.HasStockLocator && wrapper.config.CalculateShippingCost && !wrapper.config.isSubRecipe) {
                var callbacks = {
                    onSuccess: function (response) {
                        if (response.success) {
                            wrapper.model.ShippingCost = parseFloat(response.data);
                            wrapper.calculateWeight();
                            wrapper.calculateCo2();
                            if (wrapper.config.HasTaxAndFee) {
                                wrapper.calculatePrice(false);
                                wrapper.getTaxAndFee();
                            } else {
                                wrapper.calculatePrice(false);
                            }
                        }
                    }
                };
                wrapper.storeLocator.SetCallbacks(callbacks);
                wrapper.storeLocator.GetShippingCost();
            }
            var response;
            if (wrapper.config.isSubRecipe) {
                response = Vendd.RecipeLibrary.GetModel(wrapper.model.RecipeItemId);
                if (callback && callback.success && response.success) callback.success(response);
                if (callback && callback.error && !response.success) callback.error(response);
                if (callback && callback.finally) callback.finally(response);
            }
            else if (_config.GlobalId !== "" && wrapper.config.LoadFromDatabase) {
                $.when(Vendd.RecipeLibrary.LoadFromGlobalId(_config))
                    .done(
                        function (response) {
                            if (callback && callback.success) callback.success(response);
                            return;
                        })
                    .fail(
                        function (response) {
                            if (callback && callback.error) callback.error(response);
                            return;
                        })
                    .always(
                        function (response) {
                            if (callback && callback.finally) callback.finally(response);
                            if (!wrapper.config.HasTaxAndFee) wrapper.loading(false);
                            return;
                        });
            } else if (wrapper.config.OnLoadPageLoadFromLocalStorage) {
                wrapper.config.LoadFromDatabase = false;
                response = Vendd.RecipeLibrary.LoadFromLocalRecipeItems(wrapper.model.RecipeItemId);
                if (response.success) {
                    wrapper.model.RecipeItems = response.data.Recipe.RecipeItems;
                    if (callback && callback.success) callback.success(response);
                } else {
                    wrapper.update();
                }
                if (callback && callback.finally) callback.finally(response);
                wrapper.loading(false);
            } else {
                wrapper.config.LoadFromDatabase = false;
                wrapper.update();
                wrapper.loading(false);
                $(".x-product-details-ajax-buttons .js-full-screen-popup").removeClass("disabled");
            }
        };

        wrapper.assignConfigurationToUser = function (callback, config) {
            var defaultConfiguration = {
                RecipeItemId: wrapper.config.RecipeItemId,
                callback: callback
            };
            config = $.extend({}, defaultConfiguration, config || {});

            $.when(Vendd.RecipeLibrary.AssignConfigurationToUser(config))
                .done(
                    function (response) {
                        if (callback && callback.success) callback.success(response.data);
                        return;
                    })
                .fail(
                    function (response) {
                        if (callback && callback.error) callback.error(response);
                        return;
                    })
                .always(
                    function (response) {
                        if (callback && callback.finally) callback.finally(response);
                        return;
                    });
        };

        wrapper.hideAllErrors = function () {
            $.getGlobalElement(".recipe-error-container", $wrapper).addClass("hidden");
            $.getElement(".category-items .group-error-container", $wrapper).removeAttr("data-error-codes").addClass("hidden");
            $.getElement(".category-items .info-error-container", $wrapper).removeAttr("data-error-codes").addClass("disabled");
            $.getElement(".ingredient", $wrapper).removeClass("disabled");
        };

        wrapper.showErrorMessage = function ($item, errorCodes, incompatibles, missingPrerequisites, missingAnyOfPrerequisites) {

            var $ingredient = $item.closest(".category-item");
            var $infoContainer = $(".info-error-container", $ingredient);
            if ($infoContainer.length === 0 || (errorCodes || []).length === 0) return;
            $infoContainer.attr("data-error-codes", (errorCodes || []).join(","));
            var errorHtmls = [];
            _.each((errorCodes || []), function (errorCode, idx) {
                var errorHtml = $("<div></div>").html("<p>" + (wrapper.literals["error" + errorCode] || "") + "</p>").text();
                if (errorCode === 1030) {
                    errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((incompatibles || []), function (item) { return templateInfo(item); }).join("") + "</ul>");
                }
                if (errorCode === 1031) {
                    errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((missingPrerequisites || []), function (item) { return templateInfo(item); }).join("") + "</ul>");
                }
                if (errorCode === 1032) {
                    errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((incompatibles || []), function (item) { return templateInfo(item); }).join("") + "</ul>");
                    errorHtml = errorHtml.replace("{0}", "<ul>" + _.map((missingPrerequisites || []), function (item) { return templateInfo(item); }).join("") + "</ul>");
                }
                if (errorCode === 1033) {
                    var missingAnyOfPrerequisitesHtml = "";
                    for (var i = 0; i < (missingAnyOfPrerequisites || []).length; i++) {
                        var items = missingAnyOfPrerequisites[i];
                        missingAnyOfPrerequisitesHtml += "<ul>" + _.map((items || []), function (item) { return templateInfo(item, 'type-radio'); }).join("") + "</ul>";
                    }
                    errorHtml = errorHtml.replace("{0}", missingAnyOfPrerequisitesHtml);
                }
                errorHtmls.push(errorHtml);
            });
            $(".info-error-text", $infoContainer).html(errorHtmls.join("<hr/>"));
            $(".inner-wrapper", $infoContainer).html(errorHtmls.join("<hr/>"));
            initScrollToIngredient($(".inner-wrapper .scroll-to-ingredient", $infoContainer));
            if (!wrapper.config.HasDependencies) {
                $infoContainer.removeClass("disabled").removeClass("hidden");
            }
        };

        var templateInfo = function (item, inputClass) {
            inputClass = inputClass || "";
            var template = "<li>{0}</li>";

            var titleTemplate = "<a class='scroll-to-ingredient goto-item' data-goto-ingredient-id='{0}'>{2} {1}</a>"
                .replace("{0}", item.IngredientId)
                .replace("{1}", (item.Name || ""))
                .replace("{2}", (item.DMSCode || ""));

            var referenceTemplate = titleTemplate;
            var $item = $.getElement(".ingredient[data-ingredientid='" + item.IngredientId + "']:not(.info-input)", $wrapper);
            if ($item.length > 0) {
                var isDisable = $item.is(".disabled");
                var $inputContainer = $(" > .label-container .input-container", $item).clone();
                var isRadioButton = $("input", $inputContainer).is(":radio");
                var hasNoneRadioButton = $item.siblings(".ingredient[data-ingredientid='0']").length > 0;

                 $("input", $inputContainer).attr("type", "checkbox").addClass("info-input").addClass(inputClass).attr("name", $("input", $inputContainer).attr("name") + "_error");
                 if (wrapper.config.ShowSelectionOnErrorTooltip) {
                    referenceTemplate = "<div class='reference-template input-container{2}'>{0}{1}</div>"
                        .replace("{0}", $inputContainer.html())
                        .replace("{1}", titleTemplate)
                        .replace("{2}", isDisable ? " disabled" : "");
                } else {
                    referenceTemplate = "{0}"
                        .replace("{0}", titleTemplate);
                }
            }

            template = template
                .replace("{0}", referenceTemplate);
            return template;
        }

        wrapper.showGeneralErrorMessage = function (errorItem) {
            var $templateErrors = $.getElement(" .summary-error-generate-template", $wrapper);
            _.each((errorItem.ErrorCodes || []), function (errorCode, idx) {
                var errorHtml = $("<div></div>").html("<p>" + (wrapper.literals["error" + errorCode] || "") + "</p>").text();
                var relatedItemsHtml = "";
                var $templateClone = $templateErrors.clone().removeClass("summary-error-generate-template").addClass("generated");

                if (errorItem.Id || 0 > 0) {
                    var $group = $.getElement(" .category-items[data-groupId='" + (errorItem.Id || 0) + "']", $wrapper);
                    if ($group) {
                        var groupIndex = $group.index() + 1;
                        errorHtml = errorHtml.replace("{0}", errorItem.ExtraQuantity).replace("{1}", errorItem.Name).replace("{2}", errorItem.CategoryName).replace("{3}", groupIndex);
                        $(".group-error-container", $group).attr("data-error-codes", errorCode).html(errorHtml).removeClass("hidden");
                        $templateClone.attr("data-goto-group-id", (errorItem.Id || 0)).addClass("goto-item");
                        $(".summary-item-name", $templateClone).addClass("hidden");
                    }
                } else if (errorItem.IngredientId || 0 > 0) {
                    var $ingredient = $.getElement(" .category-item[data-ingredientid='" + (errorItem.IngredientId || 0) + "']", $wrapper);
                    if ($ingredient) {
                        var template = "<li><a class='goto-item' data-goto-ingredient-id='{0}'>{2} {1}</a></li>";
                        if (errorCode === 1030) {
                            relatedItemsHtml = "<ul>" + _.map((errorItem.Incompatibles || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>";
                        }
                        if (errorCode === 1031) {
                            relatedItemsHtml = "<ul>" + _.map((errorItem.MissingPrerequisites || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>";
                        }
                        if (errorCode === 1032) {
                            relatedItemsHtml = "<ul>" + _.map((errorItem.Incompatibles || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>"
                                + "<ul>" + _.map((errorItem.MissingPrerequisites || []), function (item) { return template.replace("{0}", item.IngredientId).replace("{1}", item.Name).replace("{2}", item.ManufacturerProductCode); }).join("") + "</ul>";
                        }
                        $(".summary-related-items", $templateClone).html(relatedItemsHtml);
                        errorHtml = errorHtml.replace("{0}", "");
                    }
                } else {
                    errorHtml = errorHtml.replace("{0}", errorItem.ExtraQuantity).replace("{1}", errorItem.Name);
                    $.getGlobalElement(".recipe-error-container", $wrapper).html(errorHtml).removeClass("hidden");
                }

                if ((errorItem.IngredientId || 0 > 0)) {
                    $(".summary-item-name", $templateClone).text(errorItem.Name)
                        .addClass("scroll-to-ingredient")
                        .attr("data-goto-ingredient-id", (errorItem.IngredientId || 0))
                        .addClass("goto-item");
                }
                $(".summary-error", $templateClone).html(errorHtml);
                var $parent = $.getElement(" .summary-category-general-errors .category-items", $wrapper);
                $templateClone.appendTo($parent);
                $(".goto-item", $templateClone).each(function () {
                    initScrollToIngredient($(this));
                });
                if ($templateClone.hasClass("goto-item")) initScrollToIngredient($templateClone);
            });
        };

        wrapper.Dependencies = {};
        wrapper.Dependencies.hideAll = function () {
            $.getGlobalElement(".recipe-dependencies-container", $wrapper).html("").addClass("hidden");
            $.getGlobalElement(".recipe-dependencies-button", $wrapper).addClass("hidden");
        };

        wrapper.Dependencies.show = function () {

            var result = Vendd.RecipeLibrary.SetDependencies(wrapper.model.RecipeItemId);
            if (!result.success) {
                $.getElement(" input[data-ingredientid]", $wrapper).removeClass("loading");
                return;
            }
            $.getElement(" input[data-ingredientid]", $wrapper)
                .addClass('disabled').prop("disabled", true);
            _.each(result.data, function (d) {
                if (((d.DepedenciesIngredientsOnAdd || []).length === 0) || !d.IngredientId || !d.HasDependencies) return;
                var $input = $.getElement(` input[data-ingredientid="${d.IngredientId}"]`, $wrapper);
                if (!$input) return;
                var $dependencyContainer = $.getGlobalElement(`.recipe-dependencies-container[data-ingredientid="${d.IngredientId}"]`, $wrapper);
                var $dependencyButton = $.getGlobalElement(`.recipe-dependencies-button[data-ingredientid="${d.IngredientId}"]`, $wrapper);
                if (!$dependencyContainer || !$dependencyButton) {
                    $dependencyContainer.addClass("hidden");
                    $dependencyButton.addClass("hidden");
                    return;
                }
                if ((d.DepedenciesIngredientsOnAdd || []).length > 0 && d.HasDependencies) {
                    _.each(d.DepedenciesIngredientsOnAdd, function (x) {
                        x.PriceText = numberToString2(x.PriceText, true) || numberToString2(0, true);
                        x.PriceWithoutVatText = numberToString2(x.PriceWithoutVat, true) || numberToString2(0, true);
                    });
                    var dependencyModel = {
                        data: d,
                        literals: wrapper.literals
                    };
                    var html = Vendd.Handlebars.parse(wrapper.config.DependecyHtml, dependencyModel);
                    $dependencyContainer.html(html);
                    $dependencyButton.removeClass("hidden");
                    $dependencyContainer.removeClass("hidden");
                }
            });


        };

        wrapper.Dependencies.template = function (item, inputClass) {
            inputClass = inputClass || "";
            var template = "<li>{0}</li>";

            var titleTemplate = "<a class='scroll-to-ingredient goto-item' data-goto-ingredient-id='{0}'>{2} {1}</a>"
                .replace("{0}", item.IngredientId)
                .replace("{1}", (item.Name || ""))
                .replace("{2}", (item.DMSCode || ""));

            var referenceTemplate = titleTemplate;
            var $item = $.getElement(".ingredient[data-ingredientid='" + item.IngredientId + "']:not(.info-input)", $wrapper);
            if ($item.length > 0) {
                var isDisable = $item.is(".disabled");
                var $inputContainer = $(" > .label-container .input-container", $item).clone();
                var isRadioButton = $("input", $inputContainer).is(":radio");
                var hasNoneRadioButton = $item.siblings(".ingredient[data-ingredientid='0']").length > 0;

                $("input", $inputContainer).attr("type", "checkbox").addClass("info-input").addClass(inputClass).attr("name", $("input", $inputContainer).attr("name") + "_error");
                if (wrapper.config.ShowSelectionOnErrorTooltip) {
                    referenceTemplate = "<div class='reference-template input-container{2}'>{0}{1}</div>"
                        .replace("{0}", $inputContainer.html())
                        .replace("{1}", titleTemplate)
                        .replace("{2}", isDisable ? " disabled" : "");
                } else {
                    referenceTemplate = "{0}"
                        .replace("{0}", titleTemplate);
                }
            }

            template = template
                .replace("{0}", referenceTemplate);
            return template;
        }

        wrapper.checkChanges = function () {
            var localStorageHashCode = Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode(wrapper.model.RecipeItemId);
            var hasChanges = wrapper.model.HashCode !== localStorageHashCode;
            $(".globalid-container").text(wrapper.model.GlobalId).toggleClass("unsaved", hasChanges);
            $(".hashcode-container").text(wrapper.model.HashCode).toggleClass("unsaved", hasChanges);
            if (wrapper.config.SaveToLocalStorage) (Vendd.RecipeLibrary.SaveRecipeItemsToLocal(wrapper.model.RecipeItemId, wrapper.model.GlobalId)).success;
        };

        wrapper.setCheckedItems = function () {
            var result;
            if (wrapper.config.isSubRecipe) {
                result = (Vendd.RecipeLibrary.GetCheckedRecipeItems(wrapper.config.ParentRecipeItemId));
            }
            else {
                result = (Vendd.RecipeLibrary.GetCheckedRecipeItems(wrapper.model.RecipeItemId));
            }
            if (!result.success) {
            } else {
                var $standard;
                if (wrapper.config.StandardEquipmentWrapper !== "") {
                    $standard = $("" + wrapper.config.StandardEquipmentWrapper);
                }
                if ($standard && $standard.length) {
                    $(".category-item.generated", $standard).remove();
                }

                $.getGlobalElement(" .view-standard-equipments", $wrapper).addClass("hidden");
                $.getGlobalElement(" .summary-category-standard-equipment .category-item.generated", $wrapper).remove();
                $.getGlobalElement(" .summary-category-optional-equipment .category-item.generated", $wrapper).remove();
                $.getGlobalElement(" .summary-category-general-errors .category-item.generated", $wrapper).remove();
                $.getGlobalElement(" .summary-category-outdated-equipment .category-item.generated", $wrapper).remove();
                var $template = $.getGlobalElement(".summary-item-generate-template", $wrapper);
                $.getElement(" input[data-ingredientid]", $wrapper)
                    .addClass('loading')
                    .off('change')
                    .prop("checked", false).removeClass("active");
                $('.x-recipe-ingredients-wrapper.issubrecipe', $wrapper).addClass("hidden");
                var checkedRecipes = _.groupBy(result.data.CheckedRecipeItems || [], function (item) { return item.Category; });
                _.each(checkedRecipes, function (items, category) {
                    var firstStandard = true;
                    _.each(items, function (item, idx) {
                        if (wrapper.config.isSubRecipe && item.ProductItemId === wrapper.model.RecipeItemId) {
                        }
                        if (item.IngredientId !== 0) {
                            var $templateClone = $template.clone().removeClass("summary-item-generate-template").addClass("generated");
                            $templateClone.attr("data-ingredientid", item.IngredientId);
                            var IsStandard = '';
                            if (item.IsStandard && item.IsMandatory) {
                                IsStandard = 'pdf-standard';
                            }
                            $(".summary-item-name", $templateClone).text(item.Name);
                            $(".summary-item-category", $templateClone).text(item.Category);
                            if (!!item.DMSCode) {
                                $(".summary-item-code .dms-code", $templateClone).text(item.DMSCode);
                            } else {
                                $(".summary-item-code", $templateClone).addClass('hidden');
                            }
                            $(".summary-item-image img", $templateClone).attr("src", item.ImageUrl).parent().addClass(IsStandard);
                            var price = item.TotalPrice > 0 ? numberToString2(item.TotalPrice, true) : numberToString2(0, true);
                            $(".summary-item-price", $templateClone).text(price).addClass(IsStandard);
                            var priceWithoutVat = item.TotalPriceWithoutVat > 0 ? numberToString2(item.TotalPriceWithoutVat, true) : numberToString2(0, true);
                            $(".summary-item-price-without-vat", $templateClone).text(priceWithoutVat).addClass(IsStandard);
                            var $parent = item.IsStandard && item.IsMandatory ?
                                $(".category.summary-category-standard-equipment .category-items") :
                                $(".category.summary-category-optional-equipment .category-items");
                            $templateClone.prependTo($parent);
                            if ($standard && $standard.length && item.IsMandatory) {
                                if (firstStandard && !wrapper.config.ShowStandardEquipment) {
                                    $.getGlobalElement(" .view-standard-equipments", $wrapper).removeClass("hidden");
                                    firstStandard = !firstStandard;
                                } else {
                                    $(".summary-item-category", $templateClone).addClass("hidden");
                                }
                                $templateClone.clone().appendTo($standard);
                            }
                        }

                        if (item.RecipeItemId !== wrapper.model.RecipeItemId) return;
                        var $elements = $.getElement("  input[data-groupid='" + item.GroupId + "'][data-ingredientid='" + item.IngredientId + "']:not(.info-input)", $wrapper);
                        $elements.each(function (i, el) {
                            var $el = $(el);
                            $el
                                .prop("checked", true)
                                .addClass("active");
                        });
                        var $ingredient = $elements.closest(".ingredient");
                        $('.x-recipe-ingredients-wrapper', $ingredient).removeClass("hidden");
                    });
                });
                var checkedItemsStandardTotal = $.getElement(".category.summary-category-standard-equipment ul.category-items > li.category-item.generated", $wrapper).length || 0;
                var checkedItemsOptionalTotal = $.getElement(".category.summary-category-optional-equipment ul.category-items > li.category-item.generated", $wrapper).length || 0;
                $.getElement(" .category.summary-category-standard-equipment", $wrapper).toggleClass("hidden", checkedItemsStandardTotal === 0);
                $.getElement(" .category.summary-category-optional-equipment", $wrapper).toggleClass("hidden", checkedItemsOptionalTotal === 0);

                if (wrapper.model.ParentRecipeItemId === 0) {
                    wrapper.calculateWeight();
                    wrapper.calculateCo2();
                    if (wrapper.config.HasTaxAndFee) {
                        wrapper.calculatePrice(false);
                        wrapper.getTaxAndFee();
                    } else {
                        wrapper.calculatePrice(false);
                    }
                } else {
                    var parentWrapper = $wrapper.parents('.x-recipe-ingredients-wrapper').get(0);
                    if (parentWrapper) {
                        parentWrapper.calculateWeight();
                        wrapper.calculateCo2();
                        if (wrapper.config.HasTaxAndFee) {
                            wrapper.calculatePrice(false);
                            wrapper.getTaxAndFee();
                        } else {
                            wrapper.calculatePrice(false);
                        }
                    }
                }
            }
        };

        wrapper.checkIfLoggedIn = function () {
            var user = JSON.parse(localStorage.getItem('CurrentUserModel'));
            if (user !== null && user.FirstName && user.LastName) {
                $('.pdf-header-subtitle').hide();
                $('.pdf-header-logedin-subtitle').append('<span>' + user.FirstName + ' ' + user.LastName + '</span>').show();
            } else {
                $('.pdf-header-logedin-subtitle').hide();
                $('.pdf-header-subtitle').show();
            }
        };

        wrapper.setEnabledItems = function () {
            if (wrapper.config.HasDependencies) {
                wrapper.Dependencies.hideAll();
                wrapper.Dependencies.show();
            }
            wrapper.hideAllErrors();
            var result = Vendd.RecipeLibrary.GetEnabledItems(wrapper.model.RecipeItemId);
            if (!result.success) {
                $.getElement(" input[data-ingredientid]", $wrapper).removeClass("loading");
            } else {

                if (!wrapper.config.HasDependencies) {
                    $.getElement(" input[data-ingredientid]", $wrapper)
                        .addClass('disabled').prop("disabled", true);
                }
                _.each(result.data.EnabledItems, function (item) {
                    var $item = $.getElement(" [data-groupid='" + item.GroupId + "'] input[data-ingredientid='" + item.IngredientId + "']:not(.info-input)", $wrapper);
                    var $ingredient = $item.closest(".ingredient");
                    if (item.ErrorCodes.length > 0) {
                        wrapper.showErrorMessage($item, item.ErrorCodes, item.Incompatibles, item.MissingPrerequisites, item.MissingAnyOfPrerequisites);
                    } else {
                        $(".error", $ingredient).addClass("hidden");
                    }
                    $item
                        .removeClass('disabled')
                        .prop("disabled", false);
                    $.getElement(" [data-groupid='" + item.GroupId + "'] input[data-ingredientid='" + item.IngredientId + "'].info-input", $wrapper)
                        .closest(".reference-template")
                        .removeClass('disabled');
                });
                _.each(result.data.DisableItems, function (item) {
                    var $item = $.getElement(" input[data-ingredientid='" + item.IngredientId + "']:not(.info-input)", $wrapper);
                    var $ingredient = $item.closest(".ingredient");
                    if ($ingredient.length > 0) {
                        wrapper.showErrorMessage($item, item.ErrorCodes, item.Incompatibles, item.MissingPrerequisites, item.MissingAnyOfPrerequisites);
                        if (!wrapper.config.HasDependencies) {
                            $ingredient.addClass("disabled");
                        }
                    }
                });

                _.each(result.data.Errors, function (error) {
                    wrapper.showGeneralErrorMessage(error);
                });

                _.each(result.data.GroupErrors, function (group) {
                    wrapper.showGeneralErrorMessage(group);

                });

                $.getElement(" input[data-ingredientid]", $wrapper)
                    .removeClass('loading')
                    .off('change')
                    .on('change', checkboxChange);

                $.getElement(" input[data-ingredientid].info-input", $wrapper).each(function (i, item) {
                    var $item = $(item);
                    var ingredientId = $item.data("ingredientid");
                    var $ingredient = $.getElement(" input[data-ingredientid='" + ingredientId + "']:not(.info-input)", $wrapper);
                    var isDisabled = $ingredient.is(".disabled");
                    var isChecked = $ingredient.is(":checked");
                    $item.prop("checked", isChecked);
                    $item.closest(".reference-template")
                        .toggleClass('disabled', isDisabled);
                });
                $.getElement('.reference-template:not(.disabled) .input-custom,.reference-template:not(.disabled) .checkmark.icon-check', $wrapper).off('click touchstart').on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    $this = $(this);
                    $input = $this.siblings("input");
                    $input.prop("checked", !$input.prop("checked"));
                    var checked = $input.prop("checked");
                    onIngredientsChanged = $.Deferred();
                    var ingredientId = $input.data("ingredientid");
                    var $item = $.getElement(" input[data-ingredientid='" + ingredientId + "']:not(.info-input)", $wrapper);
                    var $nextItemChecked = $this.closest(".ingredient");
                    var scrollToWindow = ($nextItemChecked.position().top - $(window).scrollTop());
                    var buttonTriggered = false;
                    if ($item.is(":radio") && !checked) {
                        var $radioButtonNone = $item.closest(".ingredient").siblings(".ingredient[data-ingredientid='0']");
                        if ($radioButtonNone.length > 0) {
                            $("input", $radioButtonNone).trigger("click");
                            buttonTriggered = true;
                        }
                    } else {
                        buttonTriggered = true;
                        $item.trigger("click");
                    }
                    if (buttonTriggered) {
                        $.when(onIngredientsChanged.promise())
                            .done(
                                function () {
                                    window.scrollTo({ top: $nextItemChecked.position().top - scrollToWindow });
                                    if ($nextItemChecked.not(".disabled")) {
                                        var nextItemIngredientId = $nextItemChecked.data("ingredientid");
                                        var $nextItemInput = $(" input[data-ingredientid='" + nextItemIngredientId + "']:not(.info-input)", $nextItemChecked);
                                        if ($nextItemInput.prop("checked") === false)
                                            $nextItemInput.trigger("click");
                                    }
                                    onIngredientsChanged = null;
                                    return;
                                })
                            .fail(
                                function () {
                                    onIngredientsChanged = null;
                                    return;
                                })
                            .always(
                                function () {
                                    onIngredientsChanged = null;
                                    return;
                                });
                        ;
                    } else {
                        onIngredientsChanged = null;
                    }
                });
            }

            if (wrapper.config.ExternalProductImageIsEnabled) {
                wrapper.seExternalImage();
            }
        };

        wrapper.seExternalImage = function () {
            var $gallery = $.getGlobalElement(".x-product-details-photo-gallery", $wrapper);
            if ($gallery.length === 0) return;
            if (wrapper.config.ExternalProductImageType === "one-dealer") {
                var $buttons = $.getGlobalElement(".external-image-buttons-wrapper", $wrapper);
                var view = $(".external-image-button.view-button.active", $buttons).data("view") || "Front";
                Vendd.RecipeLibrary.SetExternalProductImageParameter(wrapper.model.RecipeItemId, "view", view);
            } else if (wrapper.config.ExternalProductImageType === "vendallion") {
                var $buttons = $.getGlobalElement(".external-image-buttons-wrapper", $wrapper);
                var view = $(".external-image-button.view-button.active", $buttons).data("view") || "Front";
                Vendd.RecipeLibrary.SetExternalProductImageParameter(wrapper.model.RecipeItemId, "view", view);
            } else {
                var $buttons = $.getGlobalElement(".external-image-buttons-wrapper", $wrapper);
                var view = $(".external-image-button.view-button.active", $buttons).data("view") || "EXT";
                Vendd.RecipeLibrary.SetExternalProductImageParameter(wrapper.model.RecipeItemId, "view", view);
                var angle = $(".external-image-button.angle-button.active", $buttons).data("angle") || "1";
                Vendd.RecipeLibrary.SetExternalProductImageParameter(wrapper.model.RecipeItemId, "angle", angle);
            }
            var $imgs = $("img", $gallery);
            var totalImages = $imgs.length;
            if (totalImages > 0)
                $gallery.addClass("x-loading");
            var totalLoadedImages = 0;
            $imgs.each(function (_i, img) {
                var $img = $(img);
                $img.off("load").on("load", function () {
                    totalLoadedImages++;
                    if (totalImages === totalLoadedImages) {
                        $buttons.removeClass("hidden");
                        $(".external-image-button", $buttons).removeClass("disabled");
                        $gallery.addClass("loaded");
                        $gallery.removeClass("x-loading");
                    }
                });
                var width = $img.data("width") || 800;
                Vendd.RecipeLibrary.SetExternalProductImageParameter(wrapper.model.RecipeItemId, "width", width);
                Vendd.RecipeLibrary.SetExternalProductImageParameter(wrapper.model.RecipeItemId, "height", width);
                var src = Vendd.RecipeLibrary.GetExternalProductImage(wrapper.model.RecipeItemId, wrapper.config.ExternalProductImageType);
                $img.attr("src", src);
                var $fancybox = $img.closest("a.pd-fancybox");
                if ($fancybox.length > 0) {
                    if ($fancybox.hasClass("pdf-image")) $.getElement(".pdf-thumbail", $wrapper).attr("src", src);
                    $fancybox.attr("href", src);
                }
            });
        }

        wrapper.calculatePrice = function (showTaxAndFee) {
            var prices = Vendd.RecipeLibrary.GetPrices(wrapper.model.RecipeItemId) || {};
            var shippingPrice = wrapper.model.ShippingCost || 0;
            var shippingPriceText = shippingPrice > 0 ? numberToString2(shippingPrice, true) : "";
            var countryCode = LhApp.Function.QueryString.getValueOf("countryCode", "?" + Cookies.get("VisitorState") || "") || "";
            if (wrapper.config.CalculateShippingCost && !wrapper.config.ShippingCostNotIncludeInPriceCountries.includes(countryCode.toLowerCase())) {
                shippingPrice = 0;
                shippingPriceText = $('.attributes-list .js-delivery-value').data('shipping-price-text');
                $('.dealer-info-msg').toggleClass("hidden", false);
                $('.dealer-info-nonuk-msg').toggleClass("hidden", true);
            } else {
                $('.dealer-info-msg').toggleClass("hidden", true);
                $('.dealer-info-nonuk-msg').toggleClass("hidden", false);
            }
            $('.summary-shipping-price').html(shippingPriceText);
            $('.delivery-value').html(shippingPriceText);

            $('.dealer-info-msg-2').toggleClass("hidden", false);
            prices.InitialPrice = prices.InitialPrice || 0;
            prices.StandardTotalPrice = prices.StandardTotalPrice || 0;
            prices.OptionalTotalPrice = prices.OptionalTotalPrice || 0;

            prices.InitialPrice = prices.InitialPrice || 0;
            prices.StandardTotalPrice = prices.StandardTotalPrice || 0;
            prices.TotalAddonsPrice = prices.TotalAddonsPrice || 0;
            prices.OptionalTotalPrice = prices.OptionalTotalPrice || 0;
            var optionalTotalPriceText = prices.OptionalTotalPrice > 0 ? numberToString2(prices.OptionalTotalPrice, true) : numberToString2(0, true);
            var totalPrice = prices.InitialPrice + prices.OptionalTotalPrice + prices.StandardTotalPrice + shippingPrice + (prices.Fee || 0);
            var totalInitialAndOptionalPrice = prices.InitialPrice + prices.OptionalTotalPrice + prices.StandardTotalPrice;
            var totalPriceText = totalPrice > 0 ? numberToString2(totalPrice, true) : numberToString2(0, true);
            var basicPrice = prices.InitialPrice + prices.StandardTotalPrice;
            var basicPriceText = basicPrice > 0 ? numberToString2(basicPrice, true) : numberToString2(0, true);
            var addonPriceText = prices.TotalAddonsPrice > 0 ? numberToString2(prices.TotalAddonsPrice, true) : numberToString2(0, true);
            var totalInitialAndOptionalPriceText = totalInitialAndOptionalPrice > 0 ? numberToString2(totalInitialAndOptionalPrice, true) : numberToString2(0, true);
            $('.price-optional-value').html(optionalTotalPriceText);
            $('.price-addons-value').html(addonPriceText);
            $('.total-initial-optional-price').html(totalInitialAndOptionalPriceText);
            $('.total-price').html(totalPriceText);
            $('.basic-price').html(basicPriceText);

            if (wrapper.config.HasTaxAndFee && showTaxAndFee) {
                var feePriceText = prices.Fee >= 0 ? numberToString2(prices.Fee, true) : numberToString2(0, true);
                var taxPriceText = prices.Tax >= 0 ? numberToString2(prices.Tax, true) : numberToString2(0, true);
                $('.calculate-tax-and-fee').addClass("hidden");
                $('.price-fee-value').toggleClass("hidden", !wrapper.IsValidTaxAndFee).html(feePriceText);
                $('.price-tax-value').toggleClass("hidden", !wrapper.IsValidTaxAndFee).html(taxPriceText);
                $('.invalid-tax-and-fee').toggleClass("hidden", wrapper.IsValidTaxAndFee);
            }

            prices.InitialPriceWithoutVat = prices.InitialPriceWithoutVat || 0;
            prices.StandardTotalPriceWithoutVat = prices.StandardTotalPriceWithoutVat || 0;
            prices.OptionalTotalPriceWithoutVat = prices.OptionalTotalPriceWithoutVat || 0;
            prices.TotalAddonsPriceWithoutVat = prices.TotalAddonsPriceWithoutVat || 0;
            var optionalTotalPriceTextWithoutVat = prices.OptionalTotalPriceWithoutVat > 0 ? numberToString2(prices.OptionalTotalPriceWithoutVat, true) : numberToString2(0, true);
            var totalInitialAndOptionalPriceWithoutVat = prices.InitialPriceWithoutVat + prices.OptionalTotalPriceWithoutVat + prices.StandardTotalPriceWithoutVat;
            var totalPriceWithoutVat = prices.InitialPriceWithoutVat + prices.OptionalTotalPriceWithoutVat + prices.StandardTotalPriceWithoutVat + shippingPrice + (prices.Fee || 0);
            var totalPriceWithoutVatText = totalPriceWithoutVat > 0 ? numberToString2(totalPriceWithoutVat, true) : numberToString2(0, true);
            var basicPriceWithoutVat = prices.InitialPriceWithoutVat + prices.StandardTotalPriceWithoutVat;
            var basicPriceWithoutVatText = basicPriceWithoutVat > 0 ? numberToString2(basicPriceWithoutVat, true) : numberToString2(0, true);
            var addonPriceWithoutVatText = prices.TotalAddonsPriceWithoutVat > 0 ? numberToString2(prices.TotalAddonsPriceWithoutVat, true) : numberToString2(0, true);
            var totalInitialAndOptionalPriceWithoutVatText = totalInitialAndOptionalPriceWithoutVat > 0 ? numberToString2(totalInitialAndOptionalPriceWithoutVat, true) : numberToString2(0, true);
            $('.price-optional-value-without-vat').html(optionalTotalPriceTextWithoutVat);
            $('.price-addons-value-without-vat').html(addonPriceWithoutVatText);
            $('.total-initial-optional-price-without-vat').html(totalInitialAndOptionalPriceWithoutVatText);
            $('.total-price-without-vat').html(totalPriceWithoutVatText);
            $('.basic-price-without-vat').html(basicPriceWithoutVatText);

            var vatPriceText = prices.VATAmount > 0 ? numberToString2(prices.VATAmount, true) : numberToString2(0, true);
            $('.total-vat-value').html(vatPriceText);
        };

        wrapper.calculateWeight = function () {
            var weightObj = Vendd.RecipeLibrary.GetWeight(wrapper.model.RecipeItemId) || {};
            if (wrapper.config.CalculateMaxCapacity) {
                var maxCapacityWeight = _.find(wrapper.model.Attributes || [], function (a) { return a.Code === wrapper.config.MaxCapacityAtributCode; }) || {};
                var remainingWeight = parseInt(maxCapacityWeight.Value || 0) - (weightObj.InitialWeight + weightObj.OptionalTotalWeight);
                $('.optional-weight-capacity .value').html(weightObj.OptionalTotalWeight);
                $('.total-weight-capacity .value').html((weightObj.InitialWeight + weightObj.OptionalTotalWeight));
                $('.load-capacity .value').html(remainingWeight);
                $('.load-capacity .product-details-value').toggleClass("error", remainingWeight < 0);
                Vendd.RecipeLibrary.SetWeight(wrapper.model.RecipeItemId, parseInt(maxCapacityWeight.Value || 0));

            } else {
                var remainingWeight = weightObj.InitialWeight - weightObj.OptionalTotalWeight;
                $('.load-capacity .value').html(remainingWeight);
                $('.load-capacity .product-details-value').toggleClass("error", remainingWeight < 0);
            }
        };

        wrapper.calculateCo2 = function () {
            if (wrapper.config.HasTaxAndFee) {
                var obj = Vendd.RecipeLibrary.GetCo2(wrapper.model.RecipeItemId) || {};
                $('.model-co2 .value').html(obj.InitialCo2);
                $('.total-optional-co2 .value').html(obj.OptionalTotalCo2);
                $('.total-addons-co2 .value').html(obj.AddonsTotalCo2);
                $('.total-optional-addons-co2 .value').html((obj.OptionalTotalCo2 + obj.AddonsTotalCo2));
                $('.total-co2 .value').html((obj.InitialCo2 + obj.OptionalTotalCo2 + obj.AddonsTotalCo2));
            }
        };

        wrapper.initiallizeProductRecipe = function () {
            maxQuantity = parseInt(wrapper.model.MaxQuantity);
            maxFreeQuantity = parseInt(wrapper.model.MaxFreeQuantity);
            maxReplaceQuantity = parseInt(wrapper.model.MaxReplaceQuantity);
            $('.x-recipe .description').html(wrapper.model.MaxQuantityText);
            $('.x-recipe .selected-version-label').show();
            $('.x-recipe .selected-version').html($('.x-recipe .selected-version-label')[0]);
            recipeInitialPrice = parseFloat(stringToNumber($('.x-product-details .current-price').attr('data-price')));
            $('.page_ProductList[data-step-number]').each(function (index, value) {
                var step = $(this).data("step-number");
                if ($('.price-container[data-combo-recipe' + step + ']').length === 0) return;
                var price = parseFloat(stringToNumber($('.price-container').attr("data-combo-recipe" + step)));
                recipeInitialPrice = recipeInitialPrice + price;
            });
            $('.x-product-details .current-price').html(recipeInitialPrice.toFixed(2).replace('.', ',') + '€');
            recipePrice = recipeInitialPrice;
            comboRecipePrice = 0;
            defaultQuantity = 0;
            currentQuantity = 0;
            $wrapper.get(0).recipeItems = [];
        };

        wrapper.initTooltips = function () {
            var $wrapperTooltips = $.getElement(' .tooltip-info-wrapper', $wrapper);

            if ($wrapperTooltips.length < 1)
                return;

            $wrapperTooltips.each(function (i, el) {
                intiTooltip($(el));
            });
            if (!wrapper.config.isSubRecipe) {
                $(document).off('click touchstart').on('click touchstart', function (e) {
                    if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                    var $wrapperTooltips = $.getElement(' .tooltip-info-wrapper', $wrapper);
                    var $selectedWrapper = $wrapperTooltips.is(e.target) ? $(e.target) : $(e.target).closest($wrapperTooltips).first();
                    var $toolbox = $('.info-tooltip', $selectedWrapper);
                    $('.info-tooltip', $wrapperTooltips).not($toolbox).attr('style', '');
                });
            }
        };

        var intiTooltip = function ($tooltip) {
            $tooltip.on("click touchstart", function (e) {
                if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                var $this = $(this);
                var $target = $(e.target);
                var $input = $("input:not(.info-input)", $tooltip);
                var isIngredient = $this.is('.ingredient');
                var isReferenced = $target.closest(".reference-template").length > 0;
                var isInput = $target.is("input") || $target.is(".input-custom") || $target.is(".checkmark.icon-check");
                var isCategory = $(this).is('.category-item');
                var isDisabled = $this.is('.disabled') && !isReferenced;
                var isInfoButton = $target.is(".info-btn") || $target.closest(".info-btn").length > 0;
                var isMoreInfoButton = $target.is(".more-info-btn") || $target.closest(".more-info-btn").length > 0;
                var isWrapper = $this.closest(".x-recipe-ingredients-wrapper").get(0).model.RecipeId === wrapper.model.RecipeId;
                var isError1031 = $target.is("input") && (($(".info-error-container", $tooltip).data("error-codes") || "").toString() === "1031") && $target.prop("checked"); 
                var hasError1031 = ($(".info-error-container", $tooltip).data("error-codes") || "").toString() === "1031";
                var isSelected = $input.prop("checked"); 
                if (!isWrapper) return;
                if (isIngredient && isInput && !isDisabled) return;
                if ($(this).is('.category-item') && !$(this).hasClass("disabled") && $(e.target).is("input") && !hasError1031) return;
                if ($(this).hasClass("category-title") && $(this).parent('.category').length > 0 && !$(this).parent('.category').hasClass("disabled")) return;
                if ($(this).hasClass('category-item') && $(this).find(".info-error-container").hasClass("disabled")) return;
                if (isMoreInfoButton) {
                    $target = $target.is(".more-info-btn") ? $target : $target.closest(".more-info-btn");
                    $.fancybox.open({
                        src: $target.attr("href")
                    });
                    return false;
                }

                var $tooltipBoxes = $(this).find('.info-tooltip');

                $tooltipBoxes = _.filter($tooltipBoxes, function (box) {
                    var $box = $(box);
                    var _isWrapper = $box.closest(".x-recipe-ingredients-wrapper").get(0).model.RecipeId === wrapper.model.RecipeId;
                    if (hasError1031 && !isInfoButton) {
                        if (_isWrapper) $box.show();
                        console.log("--SHOW--\n");
                    } else {
                        if (_isWrapper) $box.toggle();
                    }
                    return _isWrapper;
                });
                $('.info-tooltip', $tooltip).not($tooltipBoxes).attr('style', '');
            });
        };


        $('.standard-eq-btn').click(function (e) {
            var link =  $(this).data('link');
            $.fancybox.open({
                type : 'iframe',
                src: link
            });
        });
   
        var initScrollToIngredient = function ($item) {
            $item.on("click touchstart", function (e) {
                if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                var groupId = parseInt($(this).attr("data-goto-group-id") || "0");
                var ingredientId = parseInt($(this).attr("data-goto-ingredient-id") || "0");
                goToItem(groupId, ingredientId);
            });
        };

        var goToItem = function (groupId, ingredientId) {
            var $item = groupId > 0 ?
                $.getElement(" .configurator-container .ingredients[data-groupid='" + groupId + "']:not(.info-input)", $wrapper) :
                $.getElement(" .configurator-container .ingredient[data-ingredientid='" + ingredientId + "']:not(.info-input)", $wrapper);
            if ($item.length === 0) return;
            var $congifuratorPage = $.getElement(" .configurator-container", $wrapper);
            if (!$congifuratorPage.is(":visible")) {
                wrapper.showSummary(false);
            }
            var $category = $item.closest(".category");
            $category.toggleClass("opened", true);
            scroll_to_class($item, 90);
        };

        wrapper.initIcheck = function () {
            var $input = $.getGlobalElement('input', $wrapper);
        };

        wrapper.initIngredientsToggle = function () {
            $.getElement(' .category-title', $wrapper).click(function () {
                var $this = $(this);
                var $category = $this.closest('li.category');
                if ($category.hasClass("disabled")) return;
                $category.toggleClass("opened");
                if ($category.hasClass("wizard")) {
                    if ($category.is(":last-child")) {
                        $.getElement(" .button-show-summary-wrapper", $wrapper).removeClass("hidden");
                        $.getElement(" .button-submit-registration", $wrapper).removeClass("hidden");
                    }

                    var $nextCategory = $category.next();
                    if ($nextCategory.length > 0) {
                        $nextCategory.removeClass("disabled");
                    }
                }
            });
        };

        wrapper.initNextStep = function () {
            $.getElement(' li.category.wizard:not(:first-child):not(:nth-child(2))', $wrapper).addClass("disabled");
            if ($.getElement(' li.category.wizard', $wrapper).length === 1) {
                $.getElement(" .button-show-summary-wrapper", $wrapper).removeClass("hidden");
                $.getElement(" .button-submit-registration", $wrapper).removeClass("hidden");
            }

            $.getElement(' .next-step-center', $wrapper).on("click", function () {
                var $this = $(this);
                var $category = $this.closest('li.category');
                var $categoryTitle = $category.find('.category-title');

                if ($category.hasClass("disabled")) return;

                $category.removeClass("opened");

                var $nextCategory = $category.next();
                if ($nextCategory.length > 0) {
                    $nextCategory.addClass("opened").slideToggle(0);
                    $nextCategory.slideToggle(600);
                    scroll_to_class($nextCategory, 90);
                    if ($nextCategory.is(":last-child")) {
                        $.getElement(" .button-show-summary-wrapper", $wrapper).removeClass("hidden");
                        $.getElement(" .button-submit-registration", $wrapper).removeClass("hidden");
                    }
                    if ($nextCategory.next().length > 0) $nextCategory.next().removeClass("disabled");
                }
            });
        };

        var loadDataError = function (response, errorCode) {
            var error = (wrapper.literals["error" + (errorCode || response.status.ErrorCode || "1070")]) || "Configurator error!";
            var $errorHtml = $("<div></div>").html("<p>" + error + "</p>");
            $.fancybox.open($errorHtml, {
                touch: {
                    vertical: false,
                    momentum: false
                }
            });
            wrapper.model.IsAuthorized = (errorCode === "1061" && wrapper.config.isConfigurationPage) || wrapper.model.IsAuthenticated;

            wrapper.showSummary(false);
            $(".x-product-details-ajax-buttons .js-full-screen-popup").removeClass("disabled");
            wrapper.loading(false);
        };

        var loadDataSuccess = function (response) {
            if (wrapper.config.HasStockLocator) {
            }

            if ((!response.success || !response.data || !(response.data.GlobalId && wrapper.config.LoadFromDatabase)) && !wrapper.config.isSubRecipe) {
                var errorCode = (response.data && !response.data.GlobalId ? "1071" : "1070");
                loadDataError(response, errorCode);
                return;
            }
            wrapper.model.GlobalId = response.data.GlobalId;
            wrapper.model.HashCode = response.data.HashCode;
            wrapper.model.CanEdit = response.data.CanEdit;
            if (wrapper.config.HasAddons) wrapper.model.Addons = response.data.Addons;
            $.getElement(" .globalid-container", $wrapper).text(wrapper.model.GlobalId);
            $.getElement(" .hashcode-container", $wrapper).text(wrapper.model.HashCode);

            var result;
            if (wrapper.config.isSubRecipe) {
                wrapper.model.RecipeItems = response.data.RecipeItems;
                result = Vendd.RecipeLibrary.SetRecipeItems(wrapper.model.RecipeItemId, wrapper.model.RecipeItems);
                if (!result.success) {
                    loadDataError(response, "1071");
                    return;
                }
                wrapper.update();
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
                wrapper.loading(false);
                return;
            } else if (wrapper.model.GlobalId) {
                wrapper.model.RecipeItems = response.data.RecipeItems;
                result = Vendd.RecipeLibrary.SetRecipeItems(wrapper.model.RecipeItemId, wrapper.model.RecipeItems);
                result.SavedGlobalIdToLocal = (Vendd.RecipeLibrary.SaveGlobalIdToLocal(wrapper.model.RecipeItemId, wrapper.model.GlobalId)).success;
                if (wrapper.config.SaveToLocalStorage && wrapper.model.GlobalId) result.SaveRecipeItemsToLocal = (Vendd.RecipeLibrary.SaveRecipeItemsToLocal(wrapper.model.RecipeItemId, wrapper.model.GlobalId)).success;
                if (!result.success) {
                    loadDataError(response, "1071");
                    return;
                }
            }
            wrapper.update();
            $(".configurator-container", $wrapper).addClass("hidden");

            if (response.data.IsValid) {
                var doSave = (getQueryStringValueByName("DoSave") || "") === "true";
                if (wrapper.config.HasStockLocator && !wrapper.storeLocator.Partner && !doSave) {
                    openPostCodeSelector(null);
                }
                wrapper.setCheckedItems();
                wrapper.setEnabledItems();
                if (wrapper.config.HasAddons) wrapper.initAddonsList();
            } else {
                onValidateError(response);
            }
            wrapper.showSummary(true);
            $(".x-product-details-ajax-buttons .js-full-screen-popup").removeClass("disabled");
        };

        wrapper.Validate = function () {
            var response = {};
            var data = Vendd.RecipeLibrary.IsValid(wrapper.model.RecipeItemId);
            response.data = data || {};
            _.each(_.filter(wrapper.model.RecipeItems, function (item) { return item.SubRecipeId > 0; }),
                function (recipe) {
                    var subrecipe_data = Vendd.RecipeLibrary.IsValid(recipe.ProductItemId) || {};
                    if (response.data.IsValid && !subrecipe_data.IsValid) {
                        ($(".issubrecipe[data-id='" + recipe.ProductItemId + "']").get(0)).Validate();
                    }
                    response.data.IsValid = response.data.IsValid && subrecipe_data.IsValid;
                });

            if (response.data.IsValid) {
                onValidateSuccess(response);
                wrapper.showSummary(true);
                scroll_to_class($wrapper, 90);
            } else {
                onValidateError(response);
                var $firstError = $.getElement(" .group-error-container:not(.hidden),.x-recipe-ingredients:not(.x-subrecipe) .recipe-error-container:not(.hidden)", $wrapper).first();
                if (response.data.GroupErrors.length > 0 && $firstError.length) {
                    var $categoryError = $firstError.closest(".category");
                    $categoryError.toggleClass("opened", true);
                    scroll_to_class($firstError, 90);
                } else if (response.data.IngredientsErrors.length > 0) {
                    $.each(response.data.IngredientsErrors, function (i, error) {
                        $el = $.getElement(" .ingredients .info-error-container:not(.disabled)", $wrapper).closest(".ingredient[data-ingredientid='" + error.IngredientId + "']");
                        $input = $("input:not(.info-input)", $el);
                        if ($input.is(':checked')) {
                            var $categoryError = $el.closest(".category");
                            $categoryError.toggleClass("opened", true);
                            scroll_to_class($el, 90);
                            setTimeout(function () {
                                $input.closest('.tooltip-info-wrapper').trigger("click");
                            }, 0);
                            return false;
                        }
                    });
                }
            }
            return response.data.IsValid;
        };

        var onValidateError = function (response) {

            $.getElement(" .back-to-config-container", $wrapper).toggleClass("hidden", true);
            $.getGlobalElement(".save-for-later-container .button", $wrapper).addClass("disabled").prop("disabled", true);
            if ((wrapper.model.GlobalId || 0) === 0) $.getGlobalElement(".download-pdf-container .button", $wrapper).addClass("disabled").prop("disabled", true);
            if ((wrapper.model.GlobalId || 0) === 0) $.getGlobalElement(".share-buttons .button", $wrapper).addClass("disabled").prop("disabled", true);
            if ((wrapper.model.GlobalId || 0) === 0) $.getGlobalElement(".email-buttons .button", $wrapper).addClass("disabled").prop("disabled", true);
            if ((wrapper.model.GlobalId || 0) === 0) $.getGlobalElement(".one-dealer-container .button", $wrapper).addClass("disabled").prop("disabled", true);
            $.getElement(" .summary-category-error", $wrapper).toggleClass("hidden", response.data.Errors.length === 0 && response.data.GroupErrors.length === 0 && response.data.IngredientsErrors.length === 0);
            $.getElement(' .summary-category-error .category-description a', $wrapper).off("click touchstart").on("click touchstart", function (e) {
                if ('ontouchstart' in document.documentElement && e.type !== "touchstart") return;
                wrapper.showSummary(false);
                scroll_to_class($wrapper, 90);
            });
            $.getElement(" .summary-category-error .category-item.generated", $wrapper).remove();
            $.getGlobalElement(".validate-info-container .alert", $wrapper).removeClass("hidden");
            $.getGlobalElement(".validate-info-container .warning", $wrapper).toggleClass("hidden", !((response.data.IngredientsWarnings || []).length > 0));

            var ingredientsOutdatedErrors = _.filter(response.data.IngredientsErrors, function (i) { return i.ErrorCodes.includes(1072); });
            var ingredientsGeneralErrors = _.filter(response.data.IngredientsErrors, function (i) { return !i.ErrorCodes.includes(1072); });

            $.getElement(" .summary-category-outdated-equipment", $wrapper).toggleClass("hidden", ingredientsOutdatedErrors.length === 0);
            var $templateOutdated = $.getElement(" .summary-outdated-item-generate-template", $wrapper);
            _.each(ingredientsOutdatedErrors, function (item) {
                var $templateClone = $templateOutdated.clone().removeClass("summary-outdated-item-generate-template").addClass("generated");
                $templateClone.attr("data-ingredientid", item.IngredientId);
                $(".summary-item-name", $templateClone).text(item.Name);
                var price = item.Price > 0 ? numberToString2(item.Price, true) : numberToString2(0, true);
                $(".summary-item-price", $templateClone).text(price);
                var priceWithoutVat = item.PriceWithoutVat > 0 ? numberToString2(item.PriceWithoutVat, true) : numberToString2(0, true);
                $(".summary-item-price-without-vat", $templateClone).text(priceWithoutVat);
                var $parent = $.getElement(" .summary-category-outdated-equipment .category-items", $wrapper);
                $templateClone.appendTo($parent);
            });

            _.each(ingredientsGeneralErrors, function (item) {
                wrapper.showGeneralErrorMessage(item);
            });

            $.getElement(" .summary-category-general-errors", $wrapper).toggleClass("hidden", response.data.Errors.length === 0 && response.data.GroupErrors.length === 0 && ingredientsGeneralErrors.length === 0);
            _.each(response.data.Errors, function (item) {
                wrapper.showGeneralErrorMessage(item);
            });

            _.each(response.data.GroupErrors, function (group) {
                wrapper.showGeneralErrorMessage(group);
            });

            _.each(response.data.IngredientsWarnings, function (item) {
                var $item = $.getElement(" .summary-container .category-item[data-ingredientid='" + item.IngredientId + "']", $wrapper);
                if ($item.length > 0) {
                    wrapper.showErrorMessage($item, item.ErrorCodes[0], null, null, null);//<--- fix to multiple errors
                    $item.addClass("tooltip-info-wrapper");
                    intiTooltip($item);
                };
            });
        };

        var onValidateSuccess = function (response) {

            $.getElement(" .back-to-config-container", $wrapper).toggleClass("hidden", false);
            $.getElement(" .summary-category-error", $wrapper).addClass("hidden");
            $.getElement(" .summary-category-general-errors", $wrapper).addClass("hidden");
            $.getElement(" .summary-category-outdated-equipment", $wrapper).addClass("hidden");
            $.getElement(" .summary-category-general-errors .category-item.generated", $wrapper).remove();
            $.getElement(" .summary-category-outdated-equipment .category-item.generated", $wrapper).remove();
            $.getElement(" .summary-container .info-error-container", $wrapper).addClass("disabled");
            $.getGlobalElement(".save-for-later-container .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".download-pdf-container .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".share-buttons .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".email-buttons .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".one-dealer-container .button", $wrapper).removeClass("disabled");
            $.getGlobalElement(".validate-info-container .alert", $wrapper).addClass("hidden");
            $.getGlobalElement(".validate-info-container .warning", $wrapper).toggleClass("hidden", !((response.data.IngredientsWarnings || []).length > 0));


            _.each(response.data.IngredientsWarnings, function (item) {
                var $item = $.getElement(" .category-item[data-ingredientId='" + item.IngredientId + "']", $wrapper);
                if ($item.length > 0) {
                    wrapper.showErrorMessage($item, item.ErrorCodes[0], null, null, null);//<--- fix to multiple errors
                    $item.addClass("tooltip-info-wrapper");
                    intiTooltip($item);
                };
            });
        };

        wrapper.getTaxAndFee = function (callback) {

            $('.calculate-tax-and-fee').removeClass("hidden");
            $('.price-tax-value').addClass("hidden");
            $('.price-fee-value').addClass("hidden");
            $('.invalid-tax-and-fee').addClass("hidden");

            callback = callback || {
                success: function (response) {
                    wrapper.IsValidTaxAndFee = true;
                    return;
                },
                error: function (response) {
                    notyf.error("<br/><p>Invalid data</p>", "<h5>Error with tax and fee data</h5>");
                    wrapper.IsValidTaxAndFee = false;
                    return;
                },
                finally: function (response) {
                    wrapper.calculatePrice(true);
                    return;
                }
            };

            $.when(Vendd.RecipeLibrary.GetTaxAndFee({ RecipeId: wrapper.model.RecipeItemId }))
                    .done(
                        function (response) {
                            if (callback && callback.success) callback.success(response.data);
                            return;
                        })
                    .fail(
                        function (response) {
                            var isAborted = (((response || {}).data || {}).statusText || "") === "abort";
                            if (callback && callback.error && !isAborted) callback.error(response);
                            return;
                        })
                    .always(
                        function (response) {
                            var isAborted = (((response || {}).data || {}).statusText || "") === "abort";
                            if (callback && callback.finally && !isAborted) callback.finally(response);
                            return;
                        });
        }

        wrapper.showSummary = function (show) {
            var showSummary = function (show) {
                if (show) $.getElement(' li.category:not(.summary-category-error)', $wrapper).removeClass("disabled");
                if (wrapper.config.SaveToDatabase || wrapper.config.ShareConfiguration || wrapper.config.EmailConfiguration || wrapper.config.PdfExport || wrapper.config.SendToOneDealer) {
                    if (!wrapper.config.SaveToDatabase || !wrapper.model.CanEdit) $.getGlobalElement(".button-summary-wrapper .save-for-later-container", $wrapper).remove();
                    if (!wrapper.config.ShareConfiguration) $.getGlobalElement(".button-summary-wrapper .share-container", $wrapper).remove();
                    if (!wrapper.config.EmailConfiguration) $.getGlobalElement(".button-summary-wrapper .email-container", $wrapper).remove();
                    if (!wrapper.config.PdfExport) $.getGlobalElement(".button-summary-wrapper .download-pdf-container", $wrapper).remove();
                    if (!wrapper.config.SendToOneDealer) $.getGlobalElement(".button-summary-wrapper .one-dealer-container", $wrapper).remove();
                }
                $(".button-summary-wrapper").toggleClass("hidden", !show);
                $(".recipe-buttons-container").toggleClass("hidden", !show);
                $(".recipe-buttons-container .js-full-screen-popup").toggleClass("disabled", !show);
                if (!wrapper.config.isConfigurationPage) {
                    $(".configurator-container").toggleClass("hidden", show);
                    $(".summary-container").toggleClass("hidden", !show);
                }
            }
            if (show && wrapper.config.HasTaxAndFee) {
                wrapper.loading(true);
                var callback = {
                    success: function (response) {
                        wrapper.IsValidTaxAndFee = true;
                        return;
                    },
                    error: function (response) {
                        notyf.error("<br/><p>Invalid data</p>", "<h5>Error with tax and fee data</h5>");
                        wrapper.IsValidTaxAndFee = false;
                        return;
                    },
                    finally: function (response) {
                        wrapper.calculatePrice(true);
                        showSummary(show);
                            wrapper.loading(false);
                        return;
                    }
                };
                wrapper.getTaxAndFee(callback);
            }
            else showSummary(show);
        };

        wrapper.initialize = function () {

            wrapper.model.CanEdit = true;

            if (wrapper.config.isConfigurationPage) {
                wrapper.model.RecipeItemId = parseInt(getQueryStringValueByName("ParentItemId") || "");
                wrapper.config.RecipeItemId = parseInt(getQueryStringValueByName("ParentItemId") || "");
                path = parseInt(getQueryStringValueByName("ItemPathChecksum") || path || "");
            }

            var vendd = getParentOrSelfVendd();

            var getUserViewModelSuccess = function () {

                wrapper.model.LoginPage = LhApp.Url.Page.Login + "?returnUrl=" + encodeURI(window.location);

                var globalId = getQueryStringValueByName("GlobalId") || "";
                var doSave = (getQueryStringValueByName("DoSave") || "") === "true";
                var callback = {}, config = {};
                if (wrapper.model.isAuthenticated && wrapper.config.SaveToDatabase && globalId !== "" && doSave) {
                    callback = {
                        success: function (response) {
                            var $successHtml = $.getGlobalElement('.success-for-later-text', $wrapper);
                            var location = UpdateQueryString("DoSave", false);
                            $("#saved-url", $successHtml).val(location);
                            $.fancybox.open($successHtml, {
                                touch: false,
                                afterClose: function () {
                                    openPostCodeSelector(null);
                                }
                            });
                        }, error: function () {
                        }, finally: function () {
                        }
                    };
                    config = {
                        GlobalId: globalId
                    };
                    wrapper.assignConfigurationToUser(callback, config);
                }

                var hasPermissions = !wrapper.config.HasAuthorizedPage ||
                    (wrapper.model.isAuthenticated && wrapper.config.HasAuthorizedPage) ||
                    (globalId !== "" && wrapper.config.LoadFromDatabase) ||
                    wrapper.config.isConfigurationPage;

                if (wrapper.config.isSubRecipe) {
                    var _ingredients = ((Vendd.RecipeLibrary.GetModel(wrapper.config.ParentRecipeItemId).data || {}).Ingredients) || {};
                    var _model = (_.find(_ingredients, function (i) { return i.SubRecipeId === wrapper.config.RecipeId }) || {}).SubRecipe || {};
                    wrapper.model = _model;
                    wrapper.model.RecipeItemId = wrapper.model.ProductItemId || 0;
                    var result = Vendd.RecipeLibrary.GetModel(wrapper.model.RecipeItemId);
                    wrapper.model = $.extend({}, wrapper.model, result.data);
                    wrapper.initModel = $.extend(true, {}, wrapper.model);

                    callback = {
                        success: loadDataSuccess,
                        error: loadDataError
                    };
                    config = {
                        GlobalId: globalId || ""
                    };
                    wrapper.loadData(callback, config);
                    return;
                }

                if (hasPermissions) {
                    var ingredientsAttributes = wrapper.config.IngredientsAttributes.split(",");
                    var attributes = wrapper.config.Attributes.split(",");
                    vendd.MessageBus.subscribe(vendd.Recipe.Messages.GetModelSuccess, wrapper, function (envelope) {
                        if (wrapper.config.isSubRecipe) return;
                        var recipeId = (envelope.message.data || {}).RecipeId || 0;
                        wrapper.model.RecipeId = recipeId;

                        var hasCategoryData = ((envelope.message.data || {}).Categories || []).length > 0;
                        if (($('.x-recipe-ingredients-wrapper.issubrecipe[data-recipe-id="' + wrapper.model.RecipeId + '"]').length > 0 && wrapper.config.RecipeId !== wrapper.model.RecipeId) || !hasCategoryData) {
                            wrapper.loading(false);
                            return;
                        }
                        wrapper.model.RecipeItemId = (envelope.message.data || {}).ProductItemId || 0;
                        wrapper.model.ParentRecipeId = wrapper.config.ParentRecipeId;
                        wrapper.model.ParentRecipeItemId = wrapper.config.ParentRecipeItemId;
                        wrapper.model = $.extend({}, wrapper.model, envelope.message.data);
                        wrapper.model.IsAuthorized = true;

                        if (wrapper.config.isConfigurationPage) {
                            wrapper.model.RecipeItemId = parseInt(getQueryStringValueByName("ParentItemId") || "");
                            wrapper.model.vin = getQueryStringValueByName("Vin") || "";
                            wrapper.model.partnerId = parseInt(getQueryStringValueByName("PartnerId") || "");
                            wrapper.model.isValidConfigurationPage = wrapper.model.RecipeItemId !== 0 && wrapper.model.vin !== "" && wrapper.model.partnerId !== 0;
                            wrapper.model.isConfigurationPage = true;
                        }

                        wrapper.RefurbModel();

                        wrapper.model.Co2AttributeCode = wrapper.config.Co2AttributeCode;
                        wrapper.model.FuelTypeCodeAttributeCode = wrapper.config.FuelTypeCodeAttributeCode;
                        wrapper.model.EngineDisplacementAttributeCode = wrapper.config.EngineDisplacementAttributeCode;
                        wrapper.model.VehicleTypeCodeAttributeCode = wrapper.config.VehicleTypeCodeAttributeCode;

                        wrapper.model.IsWheelAttributeCode = wrapper.config.IsWheelAttributeCode;
                        wrapper.model.IsBodyAttributeCode = wrapper.config.IsBodyAttributeCode;
                        wrapper.model.IsSeatAttributeCode = wrapper.config.IsSeatAttributeCode;

                        wrapper.model.DMSCodeAttributeCode = wrapper.config.DMSCodeAttributeCode;

                        wrapper.model.BodyStyleCodeAttributeCode = wrapper.config.BodyStyleCodeAttributeCode;
                        wrapper.model.GrossWeightAttributeCode = wrapper.config.GrossWeightAttributeCode;
                        wrapper.model.NumberOfSeatsAttributeCode = wrapper.config.NumberOfSeatsAttributeCode;

                        var result = Vendd.RecipeLibrary.InitRecipe(wrapper.model, wrapper.model.RecipeItemId, wrapper.config.SortIngredientsBy);
                        wrapper.model = $.extend({}, wrapper.model, result.data.recipe);
                        wrapper.initModel = $.extend(true, {}, wrapper.model);
                        if (wrapper.config.ExternalProductImageIsEnabled) {
                            $.getGlobalElement(".external-image-buttons-wrapper[data-type!='" + wrapper.config.ExternalProductImageType + "']", $wrapper).remove();
                            Vendd.RecipeLibrary.InitExternalProductImageData(wrapper.model.RecipeItemId, wrapper.config.ExternalProductImageUri);

                            wrapper.seExternalImage();
                        }

                        var callback = {
                            success: loadDataSuccess,
                            error: loadDataError
                        };
                        var config = {
                            GlobalId: globalId || ""
                        };
                        wrapper.loadData(callback, config);
                    });
                    vendd.MessageBus.subscribe(vendd.Recipe.Messages.GetModelFailure, wrapper, function (envelope) {
                        loadDataError({}, "1001");
                        return;
                    });
                    vendd.MessageBus.publishAsync(wrapper, new vendd.Recipe.Messages.GetModel(wrapper.config.RecipeItemId, path, attributes, ingredientsAttributes));
                } else {
                    wrapper.model.IsAuthorized = false;
                    wrapper.initModel = $.extend(true, {}, wrapper.model);
                    wrapper.update();
                    wrapper.loading(false);
                }
            };
            if (window.localStorage && window.localStorage.getItem("CurrentUserModel")) {
                wrapper.model.isAuthenticated = (JSON.parse(window.localStorage.getItem("CurrentUserModel") || "")).IsAuthenticated || false;
                getUserViewModelSuccess();
            } else {
                vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, wrapper, function (envelope) {
                    wrapper.model.isAuthenticated = (((envelope.message || {}).data || {}).model || {}).IsAuthenticated || false;
                    getUserViewModelSuccess();
                });
            }

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetShippingModelSuccess, wrapper, function (envelope) {
                wrapper.shippingModel = (((envelope.message || {}).data || {}).model || {});
            });
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyShippingDataSuccess, wrapper, function (envelope) {
                wrapper.model.ShippingCost = parseFloat(stringToNumber(wrapper.shippingModel.ShippingCostText));
                wrapper.model.ShippingCostText = wrapper.shippingModel.ShippingCostText;
                $.getElement(' .summary-shipping-price', $wrapper).html(wrapper.model.ShippingCostText);
            });
        };

        wrapper.RefurbModel = function () {
            $.each(wrapper.model.Categories, function (indexCategory, category) {
                category.IsVisible = false;
                $.each(category.Groups, function (indexGroup, group) {
                    group.IsVisible = false;
                    $.each(group.VisualGroups, function (indexGroup, visualgroup) {
                        visualgroup.IsVisible = false;
                        $.each(visualgroup.Items, function (indexItem, item) {
                            if (wrapper.config.ShowStandardEquipment) {
                                category.IsVisible = true;
                                group.IsVisible = true;
                                visualgroup.IsVisible = true;
                                item.IsVisible = true;
                            } else {
                                category.IsVisible = category.IsVisible || item.CanRemove;
                                group.IsVisible = group.IsVisible || item.CanRemove;
                                visualgroup.IsVisible = visualgroup.IsVisible || item.CanRemove;
                                item.IsVisible = item.CanRemove;
                            }
                        });
                    });
                });
            });
        }

        if (wrapper.config.HasStockLocator) {
            wrapper.storeLocator = (Vendd.StoreLocator || {}).Controller || {};
            var callbacks = {
                onSuccess: function (response) {
                    if (response.success) {
                        wrapper.model.ShippingCost = parseFloat(response.data);
                    }
                }
            };
            if (Object.keys(wrapper.storeLocator).length !== 0) {
                if (!wrapper.storeLocator.IsValid) {
                    console.log("Invalid Store Locator : Must set configuration for store locator");
                    loadDataError({}, "1000");
                    return;
                }
                if (wrapper.config.CalculateShippingCost) {
                    wrapper.storeLocator.SetCallbacks(callbacks);
                    wrapper.storeLocator.GetShippingCost();
                }
                wrapper.initialize();
            } else {
                Vendd.MessageBus.subscribe(Vendd.StoreLocator.Messages.Initialized, wrapper, function () {
                    wrapper.storeLocator = (Vendd.StoreLocator || {}).Controller || {};
                    if (!wrapper.storeLocator.IsValid) {
                        console.log("Invalid Store Locator : Must set configuration for store locator");
                        loadDataError({}, "1000");
                        return;
                    }
                    if (wrapper.config.CalculateShippingCost) {
                        wrapper.storeLocator.SetCallbacks(callbacks);
                        wrapper.storeLocator.GetShippingCost();
                    }
                    wrapper.initialize();
                });
            }
        } else {
            wrapper.initialize();
        }
    };

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'x-recipe-ingredients-wrapper', function (envelope) {
        bindRecipeController();
    });

    var bindRecipeController = function () {
        $('.x-recipe-ingredients-wrapper').each(function () {

            recipeController($(this), configuratorOptions, configuratorLiterals || {});
        });

        $.getGlobalElement('.js-show-recipe', $wrapper).off('click').on('click', function (e) {
            var $parent = $(this).closest('.x-recipe-ingredients-wrapper');
            if ($parent.length === 0) return;
            recipeController($parent, configuratorOptions, configuratorLiterals || {});
        });

    };

    $('.x-recipe-ingredients-wrapper').each(function () {

        recipeController($(this), configuratorOptions, configuratorLiterals || {});
    });
});

function copyToClipboard() {
    copyText = document.getElementById("saved-url");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");
}


function numberToString2(value, addCurrency, clearZeros) {
    var returnValue, currency, decimal, fractional;

    currency = LhApp.Context.Currency.Symbol;
    var doShowSymbol = LhApp.Context.Currency.DoShowSymbol;
    var symbolShownFirst = LhApp.Context.Currency.SymbolShownFirst;
    var decimalSeperator = LhApp.Context.Currency.DecimalSeparator;
    var thousandSeperator = LhApp.Context.Currency.DecimalSeparator === "." ? "," : ".";
    var numberOfDigits = LhApp.Context.Currency.NumberOfDigits;

    returnValue = parseFloat(value).toFixed(numberOfDigits);
    returnValue += "";
    returnValue = returnValue.replace('.', decimalSeperator).trim();

    if (clearZeros) {
        fractional = returnValue.split(decimalSeperator);

        if (fractional.length > 1) {
            if (new RegExp("^[0\0]+$").test(fractional[1])) {
                returnValue = fractional[0];
            }
        }
    }
    returnValue = returnValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeperator);

    if (addCurrency && doShowSymbol)
        returnValue = symbolShownFirst ? currency + " " + returnValue : returnValue + " " + currency;

    return returnValue;
}
function getShortenedUrlAuth() {
    return $.ajax({
        type: "POST",
        dataType: 'json',
        async: false,
        contentType: 'application/json; charset=UTF-8',
        url: "services/api/ExternalServices/GetShortenedUrlAuth",
        data: null
    });
}
function getShortenedUrl(url, generatePDFAfterShortener) {
    return $.when(getShortenedUrlAuth()).done(function (response) {
        var requestData = {
            "token": JSON.parse(response.message).access_token,
            "url": url
        };
        return $.ajax({
            type: "POST",
            dataType: 'json',
            async: false,
            contentType: 'application/json; charset=UTF-8',
            url: "services/api/ExternalServices/GetShortenedUrl",
            data: JSON.stringify(requestData),
            success: function (response) {
                shortUrl = JSON.parse(response.message)[0].shortFormat;
                var confUrl = window.location.href;
                if (shortUrl) {
                    confUrl = shortUrl;
                }
                $('.js-pdf-footer .shorturl').attr('href', confUrl).text(confUrl);
                generateQr(confUrl, generatePDFAfterShortener);
            },
            error: function () {
                $(".qr-wrapper").html(
                    '<img scr="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" width="1" height="1" />'
                );
            }
        });
    });
}
function generateQr(url, generatePDFAfterShortener) {
    var qrController = new QRCode($(".qr-wrapper").get(0), {
        text: "",
        width: 120,
        height: 120
    });
    qrController.makeCode(url);
    $(".qr-wrapper img:not(:last-child)").remove();
    var base64Image = ($(".qr-wrapper canvas").get(0)).toDataURL("image/png");
    $(".qr-wrapper img").removeClass("initialized").attr("src", base64Image);
    $(".qr-wrapper img").off("load").on("load", function () {
        if ($(".qr-wrapper img").is(".initialized")) return;
        $(".qr-wrapper img").addClass("initialized");
        setTimeout(generatePDFAfterShortener, 300);
    }).each(function () {
        if (this.complete) $(this).trigger('load');
    });
    $(".qr-wrapper .qr-literal").css('color', '#4999CE');
}
